import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { AiOutlineUserDelete } from "react-icons/ai";
import IconButton from "@mui/material/IconButton";
import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { FaRegCheckCircle, FaRegTimesCircle, FaExclamationTriangle } from "react-icons/fa";
import { useToast } from "../../components/ui/ToastContext";
import { jwtDecode } from 'jwt-decode';
import dayjs from "dayjs";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Divider from '@mui/material/Divider';
import OptimizedUserList1 from "../../components/ui/OptimizedUserList1";
import { AiFillEdit } from "react-icons/ai";
import Select from 'react-select';
import { MdOutlineDoneAll } from "react-icons/md";
import Tooltip from "@mui/material/Tooltip";
import { API_URL } from "../../config";
import DatePicker from "../../components/Datapicker";
import { MdWorkHistory } from "react-icons/md";
import { Checkbox } from "@mui/material";
import { logAuditUI } from "../../utils/auditLogger";

function DashboardCard24edit() {
  const { showToast } = useToast();

  const location = useLocation();
  const { item: initialData } = location.state || {};

  useEffect(() => {
    logAuditUI({
      actionType: 'OPEN_FORM',
      module: 'Planificare',
      entityId: initialData?.planning_id,
      description: `A deschis formularul de editare planificare (ID: ${initialData?.planning_id || ''})`,
    });
  }, []);
  const [selectedEditRowData, setSelectedEditRowData] = useState(initialData);
  const [plandataday, setplanDataday] = useState([]);
  const [specData, setspecData] = useState([]);
  const [userinstData, setUserinstData] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedUsers1, setSelectedUsers1] = useState([]);
  const [city, setCity] = useState([]);
  const [filinstcity, setfilinstCity] = useState([]);
  const [instcity, setinstCity] = useState([]);
  const [coment, setComent] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [searchQuery1, setSearchQuery1] = useState('');
  const [openRow, setOpenRow] = useState(null);
  const [selecteddeleteuser, setSelecteddeleteuser] = useState(null);
  const [selecteddeleteuser1, setSelecteddeleteuser1] = useState(null);
  const [selecteddeleteuser2, setSelecteddeleteuser2] = useState(null);
  const [selecteddeleteuser6, setSelecteddeleteuser6] = useState(null);
  const [selecteddeleteuser7, setSelecteddeleteuser7] = useState(null);
  const [selecteddeleteuser3, setSelecteddeleteuser3] = useState(null);
  const [user, setUser] = useState(null);
  const [selectedInstitutionId1, setSelectedInstitutionId1] = useState(null);
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [open6, setOpen6] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showGrid, setShowGrid] = useState(true);
  const [Data1, setData1] = useState([]);
  const [Data2, setData2] = useState([]);
  const [Data3, setData3] = useState([]);
  const [Data4, setData4] = useState([]);
  const getCurrentDate = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = (`0${date.getMonth() + 1}`).slice(-2);
    const day = (`0${date.getDate()}`).slice(-2);
    return `${year}-${month}-${day}`;
  };
  const [Login, setLogin] = useState(getCurrentDate());
  const [startDate, setStartDate] = useState(getCurrentDate());
  const [endDate, setEndDate] = useState(getCurrentDate());
  const [startDate1, setStartDate1] = useState(getCurrentDate());
  const [endDate1, setEndDate1] = useState(getCurrentDate());
  const [defaultOption, setDefaultOption] = useState("");
  const [defaultOption1, setDefaultOption1] = useState("");
  const [defaultOption2, setDefaultOption2] = useState("");
  const [defaultOption3, setDefaultOption3] = useState("");
  const [defaultOption5, setDefaultOption5] = useState("");
  const getCurrentTime = () => dayjs.utc().hour(8).minute(30).second(0).millisecond(0).format();
  const [startTime, setStartTime] = useState(getCurrentTime());
  const [endTime, setEndTime] = useState(getCurrentTime());
  const [isOpen7, setIsOpen7] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  // const [institution, setInstitution] = useState(null);
  const [sortConfig, setSortConfig] = useState({ key: 'date', direction: 'desc' });
  const [dateFilter, setDateFilter] = useState({
    from: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
    to: dayjs().format('YYYY-MM-DD')
  });

  const token = localStorage.getItem('jwtToken');

  useEffect(() => {
    const filter = initialData;
    if (filter) {
      const formattedDatestart = dayjs.utc(filter?.start).add(1, 'day').format("YYYY-MM-DD");
      const formattedDateend = dayjs.utc(filter?.end).format("YYYY-MM-DD");
      setStartDate(formattedDatestart);
      setEndDate(formattedDateend);
    }
  }, [initialData]);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setShowGrid(false);
  //   }, 1000);
  //   return () => clearTimeout(timer);
  // }, []);

  useEffect(() => {
    if (user?.userId) {
      const timer = setTimeout(() => {
        setShowGrid(false);
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [user?.userId]);

  useEffect(() => {
    const token = localStorage.getItem('jwtToken');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUser(decoded);
        setDefaultOption(decoded.userId);
      } catch (error) {
        console.error('Error decoding the token:', error);
      }
    }
  }, []);

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        const [
          manageUserResponse,
          usersResponse,
          specialityResponse,
          physiciansInstituteResponse,
          addressInstitutionsResponse,
          activityTypeResponse
        ] = await Promise.all([
          axios.get(`${API_URL}/api/manageuser`, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }),
          axios.get(`${API_URL}/api/users`, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }),
          axios.get(`${API_URL}/api/speciality`, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }),
          axios.get(`${API_URL}/api/physiciansinstitute`, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }),
          axios.get(`${API_URL}/api/adressinstitutions`, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }),
          axios.get(`${API_URL}/api/activitytype`, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          })
        ]);

        const users = manageUserResponse.data.filter(
          (item) => item.manager_user_id === user?.userId
        );

        if (users.length > 0) {
          const subordinateUserId = users.map((item) => item.subordinate_user_id);
          const filteredUsers = usersResponse.data.filter((item) =>
            subordinateUserId.includes(item.user_id) || item.user_id === user.userId || item.user_id === user.userId
          );
          setData1(user && user.role === 'Admin' ? usersResponse.data : filteredUsers);
        } else {
          const use = manageUserResponse.data.find((i) => i.subordinate_user_id === user?.userId);

          if (use) {
            const subordinateUserId = use.manager_user_id;
            const users1 = manageUserResponse.data.filter(
              (item) => item.manager_user_id === subordinateUserId
            ).map((item) => item.subordinate_user_id);
            const users2 = usersResponse.data.filter((item) =>
              users1.includes(item.user_id)
            );
            setData1(users2);
          } else {
            setData1([]);
          }
        }

        setspecData(specialityResponse.data);

        const val = physiciansInstituteResponse.data.filter((i) => i.is_active === true);
        setUserinstData(val);

        const item = addressInstitutionsResponse.data.filter((i) => i.institute_type_id === 2);
        setfilinstCity(item);

        setinstCity(addressInstitutionsResponse.data);
        setData4(activityTypeResponse.data);

      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (user) {
      fetchAllData();
    }
  }, [user]);

  const fetchData = async () => {
    try {
      const response = await axios.post(`${API_URL}/api/planning/details`, {
        planning_id: selectedEditRowData?.planning_id
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const structuredData = response.data.data;

      if (structuredData.length > 0) {
        const planning = structuredData[0].plannings[0];
        const dayList = planning.days;

        setStartDate(planning.start_date);
        setEndDate(planning.end_date);
        setLogin(planning.created_timestamp);

        setplanDataday(dayList);
        const details = dayList.flatMap(day => day.details);

        setSelectedInstitutionId1(planning.days[0])
        setData2(details.filter(i => i.activity_type_id !== 2));
        setData3(details.filter(i => i.activity_type_id === 2 && i.other_activity_detail_id !== null));
      }

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (selectedEditRowData && selectedEditRowData.planning_id) {
      fetchData();
    }
  }, [selectedEditRowData]);

  useEffect(() => {
    if (selecteddeleteuser) {
      deleteRowuser();
    }
  }, [selecteddeleteuser]);

  useEffect(() => {
    if (selecteddeleteuser2) {
      handleOpenRows3();
    }
  }, [selecteddeleteuser2]);

  useEffect(() => {
    if (selecteddeleteuser1) {
      handleOpenRows6();
    }
  }, [selecteddeleteuser1]);

  useEffect(() => {
    if (selecteddeleteuser6) {
      deleteRowuser2();
    }
  }, [selecteddeleteuser6]);

  useEffect(() => {
    if (selecteddeleteuser3) {
      deleteRowuser3();
    }
  }, [selecteddeleteuser3]);

  useEffect(() => {
    if (selecteddeleteuser7) {
      deleteRowuser1();
    }
  }, [selecteddeleteuser7]);

  const handleOpenRows = () => {
    setOpen(true);
  };

  const handleToggleUser = (userId) => {
    setSelectedUsers((prev) =>
      prev.includes(userId) ? prev.filter((id) => id !== userId) : [...prev, userId]
    );
  };

  const handleOpenRows1 = () => {
    setOpen1(true);
  };

  const handleToggleUser1 = (userId) => {
    setSelectedUsers1((prev) =>
      prev.includes(userId) ? prev.filter((id) => id !== userId) : [...prev, userId]
    );
  };

  const handleOpenRows2 = () => {
    setOpen2(true);
  };

  const handleOpenRows3 = () => {
    setOpen3(true);
    setComent(selecteddeleteuser2.comment)
    setComent(selecteddeleteuser2.comment)
    setDefaultOption5(selecteddeleteuser2.persons);
    setDefaultOption3(selecteddeleteuser2.activity.speciality_id);
    setDefaultOption2(selecteddeleteuser2.location?.institution_id);
    setDefaultOption1(selecteddeleteuser2.activity_type_id);
  };

  const handleOpenRows6 = () => {
    setOpen6(true);
    const startTimeFormatted = dayjs(selecteddeleteuser1.start_time);
    const endTimeFormatted = dayjs(selecteddeleteuser1.end_time);

    setStartTime(startTimeFormatted);
    setEndTime(endTimeFormatted);
  };

  const handleSave = async () => {
    if (!selectedUsers || !Array.isArray(selectedUsers) || selectedUsers.length === 0) {
      showToast({
        message: "Selectează cel puțin un medic!",
        type: "warning",
        icon: <FaRegTimesCircle className="text-yellow-600 dark:text-yellow-500" />,
      });
      return;
    }

    if (selectedInstitutionId1.add === true) {
      handleSubmit1(1);
      return;
    }

    console.log(selectedInstitutionId1)

    try {
      const requests11 = selectedUsers.map((physicianId, index) => ({
        planning_day_id: selectedInstitutionId1.planning_day_id,
        obiect_type_id: 1,
        object_id: physicianId,
        activity_type_id: 1,
        planning_id: selectedEditRowData?.planning_id,
        submited_user_id: user?.userId,
      }));

      if (requests11.length > 0) {
        await axios.post(`${API_URL}/api/planningdetail`, requests11);
      }

      setSelectedUsers("");
      setSearchQuery("")
      setOpen(false);
      handleCorrect();
      await fetchData();
    } catch (error) {
      console.error("Eroare la salvare:", error);
      handleInCorrect(error);

    }
  };

  const handleButtonClick = async () => {
    setIsLoading(true);
    try {
      await handleSave();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSave1 = async () => {
    if (!selectedUsers1 || !Array.isArray(selectedUsers1) || selectedUsers1.length === 0) {
      showToast({
        message: "Selectează cel puțin o institutie!",
        type: "warning",
        icon: <FaRegTimesCircle className="text-yellow-600 dark:text-yellow-500" />,
      });
      return;
    }

    if (selectedInstitutionId1.add === true) {
      handleSubmit1(2);
      return;
    }

    try {
      if (!selectedEditRowData?.planning_id) {
        throw new Error("planning_id is required");
      }
      if (!user?.userId) {
        throw new Error("User ID is required");
      }
      if (!selectedInstitutionId1?.planning_day_id) {
        throw new Error("planning_day_id is required");
      }

      const requests11 = selectedUsers1.map((physicianId, index) => ({
        planning_day_id: selectedInstitutionId1.planning_day_id,
        obiect_type_id: 2,
        object_id: physicianId,
        activity_type_id: 1,
        planning_id: selectedEditRowData.planning_id,
        submited_user_id: user.userId,
      }));


      if (requests11.length > 0) {
        await axios.post(`${API_URL}/api/planningdetail`, requests11);
      }
      await fetchData();
      setSelectedUsers1("");
      setSearchQuery1("")
      setOpen1(false);
      handleCorrect();

    } catch (error) {
      console.error("Error in handleSave1:", error);
    }
  };

  const handleButtonClick1 = async () => {
    setIsLoading(true);
    try {
      await handleSave1();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSave2 = async () => {
    if (!defaultOption1) {
      showToast({
        message: "Selectează cel puțin o activitate!",
        type: "warning",
        icon: <FaRegTimesCircle className="text-yellow-600 dark:text-yellow-500" />,
      });
      return;
    }

    if (selectedInstitutionId1.add === true) {
      handleSubmit();
      return;
    }

    try {
      const endTimeWithAddedMinutes = new Date(endTime);
      endTimeWithAddedMinutes.setMinutes(endTimeWithAddedMinutes.getMinutes() + 20);

      const requests12 = [{
        planning_day_id: selectedInstitutionId1.planning_day_id,
        activity_type_id: parseInt(defaultOption1, 10),
        institution_id: defaultOption2,
        speciality_id: parseInt(defaultOption3, 10),
        start_time: new Date(startTime),
        end_time: endTimeWithAddedMinutes,
        persons: defaultOption5,
        comment: coment,
        planning_id: selectedEditRowData?.planning_id,
        user_id: user?.userId,

      }];
      axios.post(`${API_URL}/api/otheractivitydetail`, requests12)


      setComent('');
      setDefaultOption5('');
      setDefaultOption3('');
      setDefaultOption2('');
      setDefaultOption1('');
      setSelectedUsers1("");
      setOpen2(false);
      handleCorrect();
      await fetchData();
    } catch (error) {
      console.error("Eroare la salvare:", error);
      handleInCorrect(error);

    }
  };

  const handleButtonClick2 = async () => {
    setIsLoading(true);
    try {
      await handleSave2();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSave3 = async () => {
    try {
      const requests13 = [
        ...Data3.filter((i) => i.other_activity_detail_id === selecteddeleteuser2.other_activity_detail_id)
          .map(dataForPlanning => {
            return {
              speciality_id: parseInt(defaultOption3, 10),
              institution_id: defaultOption2,
              start_time: dataForPlanning.start_time,
              end_time: dataForPlanning.end_time,
              comment: coment,
              persons: defaultOption5,
              other_activity_id: dataForPlanning.other_activity_detail_id,
              planning_id: selectedEditRowData?.planning_id,
              user_id: user?.userId,

            };
          })
          .filter(request => request !== null)
      ];

      await axios.put(`${API_URL}/api/changeotheractivitydetail`, requests13)

      setComent('');
      setDefaultOption5('');
      setDefaultOption3('');
      setDefaultOption2('');
      setDefaultOption1('');
      setSelecteddeleteuser2("");
      setOpen3(false);
      handleCorrect();
      await fetchData();
    } catch (error) {
      console.error("Eroare la salvare:", error);
      handleInCorrect(error);

    }
  };

  const handleButtonClick3 = async () => {
    setIsLoading(true);
    try {
      await handleSave3();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSave7 = async () => {
    try {
      const newStartTime = startTime;
      const newEndTime = endTime;
      const adjustTime = (timeString) => {
        const date = new Date(timeString);

        date.setTime(date.getTime() + 0 * 60 * 60 * 1000);

        return date.toISOString();
      };

      const requests13 = [
        ...Data3.filter((i) => i.other_activity_detail_id === selecteddeleteuser1.other_activity_detail_id)
          .map(dataForPlanning => {
            return {
              institution_id: dataForPlanning.location?.institution_id || null,
              speciality_id: dataForPlanning.activity.speciality_id,
              start_time: adjustTime(newStartTime),
              end_time: adjustTime(newEndTime),
              persons: dataForPlanning.persons,
              comment: dataForPlanning.comment,
              other_activity_id: dataForPlanning.other_activity_detail_id,
              planning_id: selectedEditRowData?.planning_id,
              user_id: user?.userId,
              other_activity_detail_id: dataForPlanning.other_activity_detail_id
            };
          })
          .filter(request => request !== null)
      ];

      await axios.put(`${API_URL}/api/changeotheractivitydetail`, requests13)

      setSelecteddeleteuser1("");
      setOpen6(false);
      handleCorrect();
      await fetchData();
    } catch (error) {
      console.error("Eroare la salvare:", error);
      handleInCorrect(error);
    }
  };

  const handleButtonClick6 = async () => {
    setIsLoading(true);
    try {
      await handleSave7();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const anulat = async () => {
    showToast({
      message: "Anulat",
      type: "success",
      icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
      duration: 20
    });
  };

  const deleteRowuser = async () => {
    showToast({
      message: (
        <div>
          <p>Sigur doriți să ștergeți această înregistrare?</p>
          <div className="flex gap-2 mt-2">
            <button
              className="px-3 py-1 bg-red-700 text-white rounded-md"
              onClick={async () => {
                await confirmDelete();
              }}
            >
              Da
            </button>
            <button
              className="px-3 py-1 bg-gray-400 text-white rounded-md"
              onClick={() => { anulat(); setSelecteddeleteuser("") }}
            >
              Nu
            </button>
          </div>
        </div>
      ),
      type: "warning",
      icon: <FaExclamationTriangle className="text-yellow-600 dark:text-yellow-500" />,
    });
  };

  const confirmDelete = async () => {

    if (selecteddeleteuser.planning_detail_id != null) {
      try {
        await axios.put(`${API_URL}/api/deleteplanningdetail`, {
          planning_detail_id: selecteddeleteuser.planning_detail_id,
          planning_id: selectedEditRowData.planning_id,
          submited_user_id: user?.userId
        });
        fetchData();
        showToast({
          message: "Datele au fost șterse cu succes!",
          type: "success",
          icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
        });
      } catch (error) {
        console.error(error);
        showToast({
          message: "Eroare la ștergerea datelor!",
          type: "error",
          icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
        });
      }
    } else {
      showToast({
        message: "ID-ul zilei de planificare este invalid.",
        type: "error",
        icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
      });
    }
  };

  const deleteRowuser1 = async () => {
    if (!selecteddeleteuser7) {
      showToast({
        message: "Nu a fost selectată nicio înregistrare pentru ștergere.",
        type: "error",
        icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
      });
      return;
    }

    showToast({
      message: (
        <div>
          <p>Sigur doriți să ștergeți această înregistrare?</p>
          <div className="flex gap-2 mt-2">
            <button
              className="px-3 py-1 bg-red-700 text-white rounded-md"
              onClick={async () => {
                await confirmDelete1();
              }}
            >
              Da
            </button>
            <button
              className="px-3 py-1 bg-gray-400 text-white rounded-md"
              onClick={() => { anulat(); setSelecteddeleteuser7("") }}
            >
              Nu
            </button>
          </div>
        </div>
      ),
      type: "warning",
      icon: <FaExclamationTriangle className="text-yellow-600 dark:text-yellow-500" />,
    });
  };

  const confirmDelete1 = async () => {
    if (selecteddeleteuser7.other_activity_detail_id != null) {
      try {
        await axios.put(`${API_URL}/api/deleteotheractivitydetail`, {
          other_activity_id: selecteddeleteuser7.other_activity_detail_id, planning_id: selectedEditRowData?.planning_id, submited_user_id: user?.userId
        });
        await fetchData();
        showToast({
          message: "Datele au fost șterse cu succes!",
          type: "success",
          icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
        });
      } catch (error) {
        console.error(error);
        showToast({
          message: "Eroare la ștergerea datelor!",
          type: "error",
          icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
        });
      } finally {
        fetchData()
      }
    } else {
      showToast({
        message: "ID-ul zilei de planificare este invalid.",
        type: "error",
        icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
      });
    }
  };

  const deleteRowuser2 = async () => {
    showToast({
      message: (
        <div>
          <p>Sigur doriți să ștergeți toate inregistrarile din aceasta zii?</p>
          <div className="flex gap-2 mt-2">
            <button
              className="px-3 py-1 bg-red-700 text-white rounded-md"
              onClick={async () => {
                await confirmDelete2();
              }}
            >
              Da
            </button>
            <button
              className="px-3 py-1 bg-gray-400 text-white rounded-md"
              onClick={() => { anulat(); setSelecteddeleteuser6("") }}
            >
              Nu
            </button>
          </div>
        </div>
      ),
      type: "warning",
      icon: <FaExclamationTriangle className="text-yellow-600 dark:text-yellow-500" />,
    });
  };

  const confirmDelete2 = async () => {
    if (selecteddeleteuser6.planning_day_id != null) {
      try {
        await axios.put(`${API_URL}/api/deleteplanningday`, {
          planning_day_id: selecteddeleteuser6.planning_day_id,
          submited_user_id: user?.userId,
          planning_id: selectedEditRowData.planning_id
        });
        await fetchData();
        showToast({
          message: "Datele au fost șterse cu succes!",
          type: "success",
          icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
        });
      } catch (error) {
        console.error(error);
        showToast({
          message: "Eroare la ștergerea datelor!",
          type: "error",
          icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
        });
      }
    } else {
      showToast({
        message: "ID-ul zilei de planificare este invalid.",
        type: "error",
        icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
      });
    }
  };

  const deleteRowuser3 = async () => {
    if (!selecteddeleteuser3) {
      showToast({
        message: "Nu a fost selectată nicio înregistrare pentru ștergere.",
        type: "error",
        icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
      });
      return;
    }

    showToast({
      message: (
        <div>
          <p>Sigur doriți să modificați înregistrarea ca vizită dublă?</p>
          <div className="flex gap-2 mt-2">
            <button
              className="px-3 py-1 bg-red-700 text-white rounded-md"
              onClick={async () => {
                await confirmDelete3();
              }}
            >
              Da
            </button>
            <button
              className="px-3 py-1 bg-gray-400 text-white rounded-md"
              onClick={() => { anulat(); setSelecteddeleteuser3("") }}
            >
              Nu
            </button>
          </div>
        </div>
      ),
      type: "warning",
      icon: <FaExclamationTriangle className="text-yellow-600 dark:text-yellow-500" />,
    });
  };

  const confirmDelete3 = async () => {

    if (selecteddeleteuser3.planning_detail_id != null) {
      try {
        await axios.post(`${API_URL}/api/update-planning-double`, {
          planning_detail_id: selecteddeleteuser3.planning_detail_id,
          is_double_visit: !selecteddeleteuser3.is_double_visit,
        });
        fetchData();
        showToast({
          message: "Datele au fost modificate cu succes!",
          type: "success",
          icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
        });
      } catch (error) {
        console.error(error);
        showToast({
          message: "Eroare la modificarea datelor!",
          type: "error",
          icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
        });
      }
    } else {
      showToast({
        message: "ID-ul zilei de planificare este invalid.",
        type: "error",
        icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
      });
    }
  };


  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };

  const generateDatesInRange = (startDate, endDate) => {
    const dates = [];
    let currentDate = dayjs(startDate);

    while (currentDate.isBefore(dayjs(endDate).add(1, 'day'))) {
      dates.push(currentDate.format("YYYY-MM-DD"));
      currentDate = currentDate.add(1, 'day');
    }
    return dates;
  };

  const getDatesWithData = (dates, data) => {
    let newId = 0;
    let index = 0;
    return dates.map(date => {
      const item = data.find(item =>
        item.date && dayjs(item.date).isValid() &&
        dayjs(item.date).isSame(dayjs(date), 'day')
      );

      if (item) {
        return { ...item, index: index++ };
      } else {
        return {
          add: true,
          date,
          planning_day_id: newId++,
          total: "Fără vizite",
          index: index++,
        };
      }
    });
  };

  const datesInRange = generateDatesInRange(startDate, endDate);
  const datesWithData = getDatesWithData(datesInRange, plandataday);

  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(datesWithData.length / itemsPerPage);
  const currentItems = datesWithData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const [currentPage1, setCurrentPage1] = useState(1);
  const totalPages1 = Math.ceil(Data2.filter((i) => i.planning_day_id === selectedInstitutionId1?.planning_day_id).length / itemsPerPage);
  const currentItems1 = Data2.filter((i) => i.planning_day_id === selectedInstitutionId1?.planning_day_id).slice(
    (currentPage1 - 1) * itemsPerPage,
    currentPage1 * itemsPerPage
  );

  const dropdownOptions = Data1.map((region) => ({
    value: region.user_id,
    label: region.user_name_surname
  }));

  const _onSelect = (selectedOption) => {
    setDefaultOption(selectedOption);
  };

  const dropdownOptions1 = Data4.map((region) => ({
    value: region.activity_type_id,
    label: region.description
  }));

  const _onSelect1 = (selectedOption) => {
    setDefaultOption1(selectedOption);
  };

  const dropdownOptions2 = instcity.map((user) => {
    const matchingInstCity = instcity.find((i) => i.id === user.id);
    const cityName = matchingInstCity ? city.find((i) => i.adress_id === matchingInstCity.adress_id)?.city_name : '';
    return {
      value: user.id,
      label: `${user.inst} - ${user.adres} ${cityName ? `(${cityName})` : ''}`,
    };
  });

  const _onSelect2 = (selectedOption) => {
    setDefaultOption2(selectedOption);
  };

  const dropdownOptions3 = specData.map((region) => ({
    value: region.speciality_id,
    label: region.description
  }));

  const _onSelect3 = (selectedOption) => {
    setDefaultOption3(selectedOption);
  };

  const handleStartTimeChange = (e) => {
    const selectedTime = e.target.value;
    const currentDate = dayjs().format("YYYY-MM-DD");

    const formattedTime = dayjs.utc(`${currentDate}T${selectedTime}`).format();

    setStartTime(formattedTime);
  };


  const handleEndTimeChange = (e) => {
    const selectedTime = e.target.value;
    const currentDate = dayjs().format("YYYY-MM-DD");

    const formattedTime = dayjs.utc(`${currentDate}T${selectedTime}`).format();

    setEndTime(formattedTime);
  };

  const handleChangecom = (event) => {
    setComent(event.target.value);
  };

  const handleCorrect = () => {
    showToast({
      message: "Datele au fost salvate cu succes!",
      type: "success",
      icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
    });
  };

  const handleInCorrect = (error) => {
    showToast({
      message: "Eroare la inserarea datelor!",
      type: "error",
      icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
    });

  };

  const handleSubmit = async (e) => {
    try {
      setLoading(true);
      await axios.put(`${API_URL}/api/changeplanning/${selectedEditRowData?.planning_id}`, {
        date: Login,
        user_id: defaultOption ? defaultOption : user.userId,
        start_date: startDate,
        end_date: endDate,
        submited_user_id: user.userId
      });

      const data = plandataday.map(item => dayjs(item.date, "MM-DD-YYYY").format("MM-DD-YYYY"));
      const dateArray = datesWithData.map(item =>
        dayjs(item.date, "MM-DD-YYYY").format("MM-DD-YYYY")
      );
      const uniqueDates = dateArray.filter(date => !data.includes(date));
      const uniqueDatesUTC = uniqueDates.map(date =>
        dayjs(date, "MM-DD-YYYY").format("YYYY-MM-DD")
      );

      let rep;
      if (uniqueDatesUTC.length > 0) {
        rep = await axios.post(`${API_URL}/api/planningday`, {
          dates: uniqueDatesUTC,
          planning_id: selectedEditRowData?.planning_id,
          submited_user_id: user?.userId
        });
      }

      const filter = rep.data.planning_day_ids;
      const ccc = datesWithData.filter((i) => i.add === true);
      const indexNecesar = ccc.findIndex(item => item.index === selectedInstitutionId1.index);
      const planning_day_id = filter[indexNecesar];

      const endTimeWithAddedMinutes = new Date(endTime);
      endTimeWithAddedMinutes.setMinutes(endTimeWithAddedMinutes.getMinutes() + 20);

      setSelectedInstitutionId1({
        ...selectedInstitutionId1,
        planning_day_id: planning_day_id,
        add: false
      });

      const requests12 = [{
        planning_day_id: planning_day_id,
        activity_type_id: parseInt(defaultOption1, 10),
        institution_id: defaultOption2,
        speciality_id: parseInt(defaultOption3, 10),
        start_time: new Date(startTime),
        end_time: endTimeWithAddedMinutes,
        persons: defaultOption5,
        comment: coment,
        planning_id: selectedEditRowData?.planning_id,
        user_id: user?.userId,
      }];

      await Promise.all([
        requests12.length > 0 && axios.post(`${API_URL}/api/otheractivitydetail`, requests12),
      ]);

      setComent('');
      setDefaultOption5('');
      setDefaultOption3('');
      setDefaultOption2('');
      setDefaultOption1('');
      setSelectedUsers1("");
      setOpen2(false);
      handleCorrect();
      await fetchData();
    } catch (error) {
      console.error(error);
      handleInCorrect(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit1 = async (e) => {
    try {
      setLoading(true);
      await axios.put(`${API_URL}/api/changeplanning/${selectedEditRowData?.planning_id}`, {
        date: Login,
        user_id: defaultOption ? defaultOption : user.userId,
        start_date: startDate,
        end_date: endDate,
        submited_user_id: user.userId
      });

      const data = plandataday.map(item => dayjs(item.date, "MM-DD-YYYY").format("MM-DD-YYYY"));
      const dateArray = datesWithData.map(item =>
        dayjs(item.date, "MM-DD-YYYY").format("MM-DD-YYYY")
      );
      const uniqueDates = dateArray.filter(date => !data.includes(date));
      const uniqueDatesUTC = uniqueDates.map(date =>
        dayjs(date, "MM-DD-YYYY").format("YYYY-MM-DD")
      );

      let rep;

      if (uniqueDatesUTC.length > 0) {
        rep = await axios.post(`${API_URL}/api/planningday`, {
          dates: uniqueDatesUTC,
          planning_id: selectedEditRowData?.planning_id,
          submited_user_id: user?.userId
        });
      }

      const filter = rep.data.planning_day_ids;
      const ccc = datesWithData.filter((i) => i.add === true);
      const indexNecesar = ccc.findIndex(item => item.index === selectedInstitutionId1.index);
      const planning_day_id = filter[indexNecesar];

      setSelectedInstitutionId1({
        ...selectedInstitutionId1,
        planning_day_id: planning_day_id,
        add: false
      });

      let requests12;
      if (e === 2) {
        requests12 = selectedUsers1
          .map((dataForPlanning) => {
            return {
              planning_day_id: planning_day_id,
              obiect_type_id: e,
              object_id: dataForPlanning,
              activity_type_id: 1,
              planning_id: selectedEditRowData?.planning_id,
              submited_user_id: user?.userId,

            };
          })
          .filter(Boolean);
      }
      else {
        requests12 = selectedUsers
          .map((dataForPlanning) => {
            return {
              planning_day_id: planning_day_id,
              obiect_type_id: e,
              object_id: dataForPlanning,
              activity_type_id: 1,
              planning_id: selectedEditRowData?.planning_id,
              submited_user_id: user?.userId,
            };
          })
          .filter(Boolean);
      }

      await axios.post(`${API_URL}/api/planningdetail`, requests12);

      setSelectedUsers1("");
      setOpen1(false);
      setSelectedUsers("");
      setSearchQuery("")
      setSearchQuery1("")
      setOpen(false);
      handleCorrect();
      await fetchData();
    } catch (error) {
      console.error(error);
      handleInCorrect(error);
    } finally {
      setLoading(false);
    }
  };

  const isDarkMode = document.documentElement.classList.contains('dark');

  const closeModal = () => {
    setIsOpen7(false);
  }

  const openModal = async (rowData) => {
    try {
      let doctorName = "-";
      let institution = "-";

      if (rowData.obiect_type_id === 1) {
        doctorName = rowData.physician?.name || "-";
      } else {
        institution = rowData.location?.institution || "-";
      }

      const usersResponse = await axios.get(`${API_URL}/api/users`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const currentUser = usersResponse.data.find((item) => item.user_id === user.userId);
      const userName = currentUser?.user_name_surname || '';
      const historyResponse = await axios.get(`${API_URL}/api/historydoc`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        params: {
          user_name_surname: userName,
          doctor: doctorName === "-" ? null : doctorName,
          institutie: institution === "-" ? null : institution
        },
      });

      setSelectedRow(historyResponse.data);
      setIsOpen7(true);
    } catch (error) {
      console.error("Error opening modal:", error);
      setSelectedRow([]);
      setIsOpen7(true);
    }
  };


  const sortedData = [...selectedRow].sort((a, b) => {
    const dateA = dayjs(a.date, "DD-MM-YYYY");
    const dateB = dayjs(b.date, "DD-MM-YYYY");

    if (sortConfig.direction === 'asc') {
      return dateA.isBefore(dateB) ? -1 : 1;
    } else {
      return dateA.isAfter(dateB) ? -1 : 1;
    }
  });

  const filteredData = sortedData.filter(item => {
    const itemDate = dayjs(item.date, "DD-MM-YYYY");
    return itemDate.isAfter(dayjs(dateFilter.from)) &&
      itemDate.isBefore(dayjs(dateFilter.to).add(1, 'day'));
  });

  const requestSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const isSpecialitateaEmpty = filteredData.every(item =>
    !item.specialitatea || item.specialitatea.trim() === ''
  );

  const [debouncedQuery, setDebouncedQuery] = useState(searchQuery);
  const [debouncedQuery1, setDebouncedQuery1] = useState(searchQuery1);

  useEffect(() => {
    const handler = setTimeout(() => setDebouncedQuery(searchQuery), 300);
    return () => clearTimeout(handler);
  }, [searchQuery]);

  useEffect(() => {
    const handler = setTimeout(() => setDebouncedQuery1(searchQuery1), 300);
    return () => clearTimeout(handler);
  }, [searchQuery1]);

  return (
    <div>
      {showGrid ? (
        <div className="flex flex-row gap-2">
          <div className="animate-pulse bg-gray-300 w-14 h-14 rounded-lg"></div>
          <div className="flex flex-col gap-2">
            <div className="animate-pulse bg-gray-300 w-28 h-5 rounded-lg"></div>
            <div className="animate-pulse bg-gray-300 w-36 h-3 rounded-lg"></div>
            <div className="animate-pulse bg-gray-300 w-36 h-2 rounded-lg"></div>
          </div>
        </div>
      ) : (
        <div className="col-span-full xl:col-span-8 bg-white dark:bg-gray-800 shadow-sm rounded-xl ">
          <form
            onSubmit={(event) => {
              event.preventDefault();
            }}
          >
            <Card className="p-2 dark:bg-gray-800 dark:text-gray-100">
              <CardHeader subheader="Informatia poate fii modificata" title="Formular" subheaderTypographyProps={{ style: { fontSize: "0.875rem", color: "#B0B0B0" } }}
                action={
                  user.role !== 'User' && (
                    <div className="relative mt-4">
                      <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 z-10">Utilizatori</label>
                      <select
                        className="w-full p-3 border rounded-md dark:bg-gray-800 dark:text-gray-100 focus:ring-2 focus:ring-blue-500 w-300 s"
                        value={defaultOption}
                        disabled={true}
                      >
                        <option value="" disabled>Alege user</option>
                        {dropdownOptions.map((option) => (
                          <option key={option.value} value={option.value}>{option.label}</option>
                        ))}
                      </select>
                    </div>
                  )
                }
              />
              <Divider className="dark:bg-gray-400" />
              <CardContent>
                <div className="md:grid md:grid-cols-1 sm:grid-cols-2 md:gap-6 lg:flex lg:gap-2">
                  <div className="relative w-full mt-3">
                    <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 z-10dark:text-gray-100">
                      Perioada: De la..
                    </label>
                    <DatePicker
                      selectedDate={startDate}
                      handleDateChange={handleStartDateChange}
                    />
                  </div>

                  <div className="relative w-full mt-3">
                    <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 z-10dark:text-gray-100">
                      Perioada: Pana la..
                    </label>
                    <DatePicker
                      selectedDate={endDate}
                      handleDateChange={handleEndDateChange}
                    />
                  </div>
                </div>

                <div className="relative mt-4">
                  <Divider className="dark:bg-gray-400" />
                  <header className="px-5 py-4 border-b border-gray-100 dark:border-gray-700/60 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 sm:gap-0">
                    <div className="relative">
                      <h2 className="font-semibold text-gray-800 dark:text-gray-100">Planificare detalii</h2>
                    </div>

                    <div className="relative w-full sm:w-auto">
                      <div className="flex flex-col sm:flex-row sm:items-center gap-2 w-full sm:gap-4">
                        {selectedInstitutionId1?.date != null ? (
                          <>
                            <button className="btn bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white"
                              onClick={handleOpenRows2}
                              disabled={selectedInstitutionId1 === null}
                            >
                              <span>Adauga Alte activitati</span>

                              <Transition appear show={open2} as={Fragment}>
                                <Dialog as="div" className="relative z-10" onClose={() => setOpen2(false)}>
                                  <Transition.Child
                                    as={Fragment}
                                    enter="ease-out duration-300"
                                    enterFrom="opacity-0"
                                    enterTo="opacity-100"
                                    leave="ease-in duration-200"
                                    leaveFrom="opacity-100"
                                    leaveTo="opacity-0"
                                  >
                                    <div className="fixed inset-0 bg-black bg-opacity-25" />
                                  </Transition.Child>

                                  <div className="fixed inset-0 overflow-y-auto">
                                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                                      <Transition.Child
                                        as={Fragment}
                                        enter="ease-out duration-300"
                                        enterFrom="opacity-0 scale-95"
                                        enterTo="opacity-100 scale-100"
                                        leave="ease-in duration-200"
                                        leaveFrom="opacity-100 scale-100"
                                        leaveTo="opacity-0 scale-95"
                                      >
                                        <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-lg bg-white p-6 text-left align-middle shadow-xl transition-all dark:bg-gray-800">
                                          <Dialog.Title as="h3" className="text-lg font-bold leading-6 text-gray-900  dark:text-gray-200">
                                            Selectează tipul activitatii
                                          </Dialog.Title>
                                          <div className="relative mt-4">
                                            <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800">Activitatea</label>
                                            <select
                                              className="w-full p-3 border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-100 focus:ring-2 focus:ring-blue-500"
                                              value={defaultOption1}
                                              onChange={(e) => _onSelect1(e.target.value)}
                                            >
                                              <option value="" disabled>Alege activitatea</option>
                                              {dropdownOptions1.map((option) => (
                                                <option key={option.value} value={option.value}>{option.label}</option>
                                              ))}
                                            </select>
                                          </div>

                                          <div className="relative mt-4">
                                            <label className="z-10 absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800">Institutia</label>
                                            <Select
                                              options={dropdownOptions2}
                                              placeholder="Caută instituția..."
                                              defaultValue={dropdownOptions2.find((opt) => opt.value === defaultOption2)}
                                              onChange={(e) => _onSelect2(e.value)}
                                              classNamePrefix="custom-select"
                                              isSearchable={true}
                                              menuPortalTarget={document.body}
                                              styles={{
                                                control: (provided) => ({
                                                  ...provided,
                                                  width: '100%',
                                                  borderRadius: '0.375rem',
                                                  borderColor: '#BFC4CD',
                                                  boxShadow: 'none',
                                                  zIndex: 0,
                                                  height: "45px",
                                                  color: isDarkMode ? '#FFFFFF' : '#1F2937',
                                                  backgroundColor: isDarkMode ? '#1f2937' : provided.backgroundColor,
                                                }),
                                                menuPortal: (base) => ({
                                                  ...base,
                                                  zIndex: 9999,
                                                  color: isDarkMode ? 'black' : base.backgroundColor,
                                                }),
                                                singleValue: provided => ({
                                                  ...provided,
                                                  color: isDarkMode ? '#FFFFFF' : '#1F2937',
                                                })
                                              }}
                                            />
                                          </div>

                                          <div className="relative mt-4">
                                            <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800">Specialitatea</label>
                                            <select
                                              className="w-full p-3 border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-100 focus:ring-2 focus:ring-blue-500"
                                              value={defaultOption3}
                                              onChange={(e) => _onSelect3(e.target.value)}
                                            >
                                              <option value="" disabled>Alege activitatea</option>
                                              {dropdownOptions3.map((option) => (
                                                <option key={option.value} value={option.value}>{option.label}</option>
                                              ))}
                                            </select>
                                          </div>

                                          <div className="relative mt-4">
                                            <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800">Numarul de persoane</label>
                                            <input
                                              type="number"
                                              className="w-full p-3 border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-100 focus:ring-2 focus:ring-blue-500"
                                              value={defaultOption5 || ""}
                                              min="0"
                                              onChange={(e) => {
                                                const newValue = e.target.value;
                                                setDefaultOption5(newValue);
                                              }}
                                            />
                                          </div>

                                          <div className="relative mt-4">
                                            <label className="absolute -top-3 left-2 text-sm bg-white px-1 z-10 dark:bg-gray-800">Comentariu</label>
                                            <textarea
                                              id="message"
                                              rows="4"
                                              className="block p-2.5 w-full text-sm text-gray-900  rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-800 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                              placeholder="Scrie aici..."
                                              value={coment}
                                              onChange={handleChangecom}
                                            />
                                          </div>

                                          <div className="mt-4 flex justify-end gap-2">
                                            <button
                                              className="px-4 py-2 rounded bg-gray-200 text-gray-700 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-200"
                                              onClick={() => setOpen2(false)}
                                            >
                                              Anulează
                                            </button>

                                            <button
                                              className={`btn ${isLoading
                                                ? "bg-gray-500 text-gray-300"
                                                : "bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white"}`}
                                              onClick={handleButtonClick2}
                                              disabled={isLoading}
                                            >
                                              {isLoading ? (
                                                <svg
                                                  className="animate-spin fill-current shrink-0 xs:hidden"
                                                  width="16"
                                                  height="16"
                                                  viewBox="0 0 16 16"
                                                >
                                                  <circle
                                                    className="opacity-25"
                                                    cx="8"
                                                    cy="8"
                                                    r="7"
                                                    stroke="currentColor"
                                                    strokeWidth="2" />
                                                  <path
                                                    className="opacity-75"
                                                    d="M12 2a6 6 0 000 12V2z" />
                                                </svg>
                                              ) : (
                                                <svg
                                                  className="fill-current shrink-0 xs:hidden"
                                                  width="16"
                                                  height="16"
                                                  viewBox="0 0 16 16"
                                                >
                                                  <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                                </svg>
                                              )}
                                              <span className="//max-xs:sr-only">
                                                {isLoading ? "Saving..." : "Salveaza detaliile"}
                                              </span>
                                            </button>
                                          </div>
                                        </Dialog.Panel>
                                      </Transition.Child>
                                    </div>
                                  </div>
                                </Dialog>
                              </Transition>
                            </button>

                            <button className="btn bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white"
                              onClick={handleOpenRows1}
                              disabled={selectedInstitutionId1 === null}
                            >
                              <span>Adauga Farmacia</span>

                              <Transition appear show={open1} as={Fragment}>
                                <Dialog as="div" className="relative z-10" onClose={() => setOpen1(false)}>
                                  <Transition.Child
                                    as={Fragment}
                                    enter="ease-out duration-300"
                                    enterFrom="opacity-0"
                                    enterTo="opacity-100"
                                    leave="ease-in duration-200"
                                    leaveFrom="opacity-100"
                                    leaveTo="opacity-0"
                                  >
                                    <div className="fixed inset-0 bg-black bg-opacity-25" />
                                  </Transition.Child>

                                  <div className="fixed inset-0 overflow-y-auto">
                                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                                      <Transition.Child
                                        as={Fragment}
                                        enter="ease-out duration-300"
                                        enterFrom="opacity-0 scale-95"
                                        enterTo="opacity-100 scale-100"
                                        leave="ease-in duration-200"
                                        leaveFrom="opacity-100 scale-100"
                                        leaveTo="opacity-0 scale-95"
                                      >
                                        <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-lg bg-white p-6 text-left align-middle shadow-xl transition-all dark:bg-gray-800">
                                          <Dialog.Title as="h3" className="text-lg font-bold leading-6 text-gray-900  dark:text-gray-200">
                                            Selectează Institutia
                                          </Dialog.Title>
                                          <div className="mt-4">
                                            <input
                                              type="text"
                                              className="w-full rounded-md border border-gray-300 bg-gray-100 px-3 py-2 focus:border-blue-500 focus:outline-none  dark:text-gray-200 dark:bg-gray-800"
                                              placeholder="Căutare Institutia"
                                              value={searchQuery1}
                                              onChange={(e) => setSearchQuery1(e.target.value)} />
                                          </div>
                                          <div className="m-2">
                                            Farmaciile selectate {selectedUsers1.length}
                                          </div>

                                          <div className="mt-2 max-h-64 overflow-y-auto">
                                            <ul>
                                              {filinstcity
                                                .filter((user) => {
                                                  const searchContent = `${user.inst} ${user.adres} ${user.city_name}`.toLowerCase();
                                                  const searchTerms = debouncedQuery1.toLowerCase().split(/\s+/).filter(Boolean);
                                                  return searchTerms.every(term => searchContent.includes(term));
                                                })
                                                .map((user) => {
                                                  return (
                                                    <li key={user.id} className="flex items-center gap-2 p-2 border-b">
                                                      <input
                                                        type="checkbox"
                                                        className="h-4 w-4"
                                                        checked={selectedUsers1.includes(user.id)}
                                                        onChange={() => handleToggleUser1(user.id, "physician")}
                                                      />
                                                      <div>
                                                        <div className="pl-4 flex items-center justify-between">
                                                          <h3 className="text-gray-900 dark:text-gray-100">{user.inst}</h3>
                                                        </div>
                                                        <div className="text-sm text-gray-500 ml-4 dark:text-gray-400">
                                                          {user.city_name} - {user.adres}
                                                        </div>
                                                      </div>
                                                    </li>
                                                  );
                                                })}

                                            </ul>
                                          </div>

                                          <div className="mt-4 flex justify-end gap-2">
                                            <button
                                              className="px-4 py-2 rounded bg-gray-200 text-gray-700 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-200"
                                              onClick={() => { setOpen1(false); setSearchQuery1("") }}
                                            >
                                              Anulează
                                            </button>

                                            <button
                                              className={`btn ${isLoading
                                                ? "bg-gray-500 text-gray-300"
                                                : "bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white"}`}
                                              onClick={handleButtonClick1}
                                              disabled={isLoading}
                                            >
                                              {isLoading ? (
                                                <svg
                                                  className="animate-spin fill-current shrink-0 xs:hidden"
                                                  width="16"
                                                  height="16"
                                                  viewBox="0 0 16 16"
                                                >
                                                  <circle
                                                    className="opacity-25"
                                                    cx="8"
                                                    cy="8"
                                                    r="7"
                                                    stroke="currentColor"
                                                    strokeWidth="2" />
                                                  <path
                                                    className="opacity-75"
                                                    d="M12 2a6 6 0 000 12V2z" />
                                                </svg>
                                              ) : (
                                                <svg
                                                  className="fill-current shrink-0 xs:hidden"
                                                  width="16"
                                                  height="16"
                                                  viewBox="0 0 16 16"
                                                >
                                                  <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                                </svg>
                                              )}
                                              <span className="//max-xs:sr-only">
                                                {isLoading ? "Saving..." : "Salveaza detaliile"}
                                              </span>
                                            </button>
                                          </div>
                                        </Dialog.Panel>
                                      </Transition.Child>
                                    </div>
                                  </div>
                                </Dialog>
                              </Transition>
                            </button>

                            <button className="btn bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white"
                              onClick={handleOpenRows}
                            >
                              <span
                              >Adauga Doctor</span>

                              <Transition appear show={open} as={Fragment}>
                                <Dialog as="div" className="relative z-10" onClose={() => setOpen(false)}>
                                  <Transition.Child
                                    as={Fragment}
                                    enter="ease-out duration-300"
                                    enterFrom="opacity-0"
                                    enterTo="opacity-100"
                                    leave="ease-in duration-200"
                                    leaveFrom="opacity-100"
                                    leaveTo="opacity-0"
                                  >
                                    <div className="fixed inset-0 bg-black bg-opacity-25" />
                                  </Transition.Child>

                                  <div className="fixed inset-0 overflow-y-auto">
                                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                                      <Transition.Child
                                        as={Fragment}
                                        enter="ease-out duration-300"
                                        enterFrom="opacity-0 scale-95"
                                        enterTo="opacity-100 scale-100"
                                        leave="ease-in duration-200"
                                        leaveFrom="opacity-100 scale-100"
                                        leaveTo="opacity-0 scale-95"
                                      >
                                        <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-lg bg-white p-6 text-left align-middle shadow-xl transition-all dark:bg-gray-800">
                                          <Dialog.Title as="h3" className="text-lg font-bold leading-6 text-gray-900 dark:text-gray-200 flex justify-between items-center">
                                          </Dialog.Title>
                                          <div className="mt-4">
                                            <input
                                              type="text"
                                              className="w-full rounded-md border border-gray-300 bg-gray-100 px-3 py-2 focus:border-blue-500 focus:outline-none  dark:text-gray-200 dark:bg-gray-800"
                                              placeholder="Căutare doctor"
                                              value={searchQuery}
                                              onChange={(e) => setSearchQuery(e.target.value)} />
                                          </div>

                                          <OptimizedUserList1
                                            Manage={userinstData}
                                            searchQuery={debouncedQuery}
                                            selectedUsers={selectedUsers}
                                            handleToggleUser={handleToggleUser}
                                            userinstData={userinstData}
                                            userspecData={userinstData}
                                            specData={specData}
                                          />

                                          <div className="mt-4 flex justify-end gap-2">
                                            <button
                                              className="px-4 py-2 rounded bg-gray-200 text-gray-700 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-200"
                                              onClick={() => { setOpen(false); setSearchQuery("") }}
                                            >
                                              Anulează
                                            </button>

                                            <button
                                              className={`btn ${isLoading
                                                ? "bg-gray-500 text-gray-300"
                                                : "bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white"}`}
                                              onClick={handleButtonClick}
                                              disabled={isLoading}
                                            >
                                              {isLoading ? (
                                                <svg
                                                  className="animate-spin fill-current shrink-0 xs:hidden"
                                                  width="16"
                                                  height="16"
                                                  viewBox="0 0 16 16"
                                                >
                                                  <circle
                                                    className="opacity-25"
                                                    cx="8"
                                                    cy="8"
                                                    r="7"
                                                    stroke="currentColor"
                                                    strokeWidth="2" />
                                                  <path
                                                    className="opacity-75"
                                                    d="M12 2a6 6 0 000 12V2z" />
                                                </svg>
                                              ) : (
                                                <svg
                                                  className="fill-current shrink-0 xs:hidden"
                                                  width="16"
                                                  height="16"
                                                  viewBox="0 0 16 16"
                                                >
                                                  <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                                </svg>
                                              )}
                                              <span className="//max-xs:sr-only">
                                                {isLoading ? "Saving..." : "Salveaza detaliile"}
                                              </span>
                                            </button>
                                          </div>
                                        </Dialog.Panel>
                                      </Transition.Child>
                                    </div>
                                  </div>
                                </Dialog>
                              </Transition>
                            </button>
                          </>
                        ) : ("")
                        }
                      </div>
                    </div>
                  </header>

                  <div className="p-3" >
                    <div className="lg:flex lg:gap-4">
                      <div className="lg:w-1/5">
                        <table className="overflow-x-auto w-full">
                          <thead className="text-xs uppercase text-gray-500 dark:text-gray-500 bg-gray-100 dark:bg-gray-700 dark:bg-opacity-50 rounded-sm">
                            <tr>
                              <th className="p-2">
                                <div className="font-semibold text-left">Data</div>
                              </th>
                              <th className="p-2">
                                <div className="font-semibold text-left">Numarul de vizite</div>
                              </th>
                              <th className="p-2">
                                <div className="font-semibold text-left">Actiune</div>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {currentItems.map((item, idx) => (

                              <tr
                                role="button"
                                key={idx}
                                className={` ${item.planning_day_id === selectedInstitutionId1?.planning_day_id ? 'bg-violet-300 dark:bg-violet-700' : ''}  ${idx % 2 === 0 ? "bg-gray-0 dark:bg-gray-800" : "bg-gray-100 dark:bg-gray-700"} hover:bg-gray-200 dark:hover:bg-gray-600`}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setSelectedInstitutionId1(item);
                                }}
                              >
                                <td className="p-2 whitespace-nowrap">
                                  <div className="text-left">{dayjs(item.date, "DD-MM-YYYY", true).format("DD-MM-YYYY")}</div>
                                </td>
                                <td className="p-2 whitespace-nowrap">
                                  <div className="text-center">
                                    {
                                      Data2.filter((i) => i.planning_day_id === item.planning_day_id).length + Data3.filter((i) => i.planning_day_id === item.planning_day_id).length
                                    }
                                  </div>
                                </td>

                                <td className="p-2 whitespace-nowrap">
                                  <div className="text-left">
                                    {(() => {
                                      const hasReportInData2 = Data2.some(
                                        (i) => i.planning_day_id === item.planning_day_id && i.report_detail_id !== null
                                      );

                                      const hasReportInData3 = Data3.some(
                                        (i) => i.planning_day_id === item.planning_day_id && i.report_detail_id !== null
                                      );

                                      return hasReportInData2 || hasReportInData3 ? (
                                        <Tooltip
                                          title={"Aveți raportări în această zi, imposibil de făcut modificări"}
                                          arrow
                                          placement="top"
                                        >
                                          <MdOutlineDoneAll className="text-green-700 text-xl ml-4" />
                                        </Tooltip>
                                      ) : (
                                        <Tooltip title="Editează" arrow placement="top">
                                          <IconButton
                                            color="primary"
                                            onClick={() => setSelecteddeleteuser6(item)}
                                            sx={{
                                              fontSize: "16px",
                                              borderRadius: "50%",
                                              "&:hover": {
                                                backgroundColor: "#a4adad",
                                              },
                                            }}
                                          >
                                            <AiOutlineUserDelete className="dark:text-gray-100" />
                                          </IconButton>
                                        </Tooltip>
                                      );
                                    })()}
                                  </div>

                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>

                        {datesWithData.length > 5 && (
                          <div className="flex justify-center mt-4">
                            <button
                              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                              className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-sm font-medium rounded-l-md hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50"
                              disabled={currentPage === 1}
                            >
                              Prev
                            </button>

                            {currentPage > 3 && (
                              <>
                                <button
                                  onClick={() => setCurrentPage(1)}
                                  className="px-4 py-2 text-sm font-medium bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                                >
                                  1
                                </button>
                                <span className="px-2">...</span>
                              </>
                            )}

                            {Array.from({ length: totalPages }, (_, index) => {
                              const page = index + 1;

                              if (
                                page === currentPage ||
                                (page >= currentPage - 1 && page <= currentPage + 1)
                              ) {
                                return (
                                  <button
                                    key={page}
                                    onClick={() => setCurrentPage(page)}
                                    className={`px-4 py-2 text-sm font-medium ${currentPage === page
                                      ? "bg-gray-500 text-white"
                                      : "bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                                      }`}
                                  >
                                    {page}
                                  </button>
                                );
                              }
                              return null;
                            })}

                            {currentPage < totalPages - 2 && (
                              <>
                                <span className="px-2">...</span>
                                <button
                                  onClick={() => setCurrentPage(totalPages)}
                                  className="px-4 py-2 text-sm font-medium bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                                >
                                  {totalPages}
                                </button>
                              </>
                            )}

                            <button
                              onClick={() =>
                                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                              }
                              className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-sm font-medium rounded-r-md hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50"
                              disabled={currentPage === totalPages}
                            >
                              Next
                            </button>
                          </div>
                        )}
                      </div>

                      <div className="lg:w-4/5 lg:mt-0 mt-4">
                        {selectedInstitutionId1 != null ? (<>
                          {Data2.filter((i) => i.planning_day_id === selectedInstitutionId1.planning_day_id && i.obiect_type_id != null).length != 0 || Data3.filter((i) => i.planning_day_id === selectedInstitutionId1.planning_day_id).length != 0 ? (
                            <>
                              <div className="overflow-x-auto">
                                {Data2.filter((i) => i.planning_day_id === selectedInstitutionId1.planning_day_id && i.obiect_type_id != null).length > 0 ? (
                                  <>
                                    <h2 className="font-semibold text-gray-700 dark:text-gray-200 max-xs:sr-only">Vizite</h2>
                                    <table className="table-auto w-full max-xs:sr-only">
                                      <thead className="text-xs uppercase text-gray-500 dark:text-gray-500 bg-gray-100 dark:bg-gray-700 dark:bg-opacity-50 rounded-sm">
                                        <tr>
                                          <th className="p-2">
                                            <div className="font-semibold text-left">Doctor</div>
                                          </th>
                                          <th className="p-2">
                                            <div className="font-semibold text-left">Specialitatea</div>
                                          </th>
                                          <th className="p-2">
                                            <div className="font-semibold text-left">Tip</div>
                                          </th>
                                          <th className="p-2">
                                            <div className="font-semibold text-left">Institutia</div>
                                          </th>
                                          <th className="p-2">
                                            <div className="font-semibold text-left">Adresa</div>
                                          </th>
                                          <th className="p-2">
                                            <div className="font-semibold text-left">Oras</div>
                                          </th>
                                          <th className="p-2">
                                            <div className="font-semibold text-left">Vizita Dubla</div>
                                          </th>
                                          <th className="p-2">
                                            <div className="font-semibold text-left">Actiune</div>
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {currentItems1.filter((i) => i.obiect_type_id !== null).map((item, idx) => (
                                          <tr
                                            key={idx}
                                            className={`text-sm font-medium divide-y divide-gray-100 dark:divide-gray-700/60 
                                            ${idx % 2 === 0 ? "bg-gray-0 dark:bg-gray-800" : "bg-gray-100 dark:bg-gray-700"}`}

                                            role="button"
                                          >
                                            <td className="p-2 whitespace-nowrap"
                                              onClick={() => openModal(item)}>
                                              <div className="text-left">
                                                {item.obiect_type_id === 1 ? (
                                                  <div className="flex items-center gap-1.5">
                                                    <span>{item.physician?.name || item.physician}</span>
                                                    {(item.physician?.data_acord || item.data_acord) ? (
                                                      <span title="Acord marketing confirmat" className="inline-flex items-center text-emerald-500 flex-shrink-0">
                                                        <svg className="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                                                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                                        </svg>
                                                      </span>
                                                    ) : null}
                                                  </div>
                                                ) : "-"}
                                              </div>
                                            </td>
                                            <td className="p-2 whitespace-nowrap"
                                              onClick={() => openModal(item)}>
                                              <div className="text-left">
                                                {item.obiect_type_id === 1 ?
                                                  item.physician?.speciality
                                                  : "-"}
                                              </div>
                                            </td>
                                            <td className="p-2 //whitespace-nowrap">
                                              <div className="text-left">
                                                {item.location?.inst_type || "Nu exista institutie"}
                                              </div>
                                            </td>
                                            <td className="p-2 //whitespace-nowrap">
                                              <div className="text-left">
                                                {item.location?.institution}
                                              </div>
                                            </td>
                                            <td className="p-2 //whitespace-nowrap">
                                              <div className="text-left">
                                                {item.location?.address}
                                              </div>
                                            </td>
                                            <td className="p-2 //whitespace-nowrap">
                                              <div className="text-left">
                                                {item.location?.city}
                                              </div>
                                            </td>
                                            <td className="p-2 //whitespace-nowrap">
                                              <div className="text-left">
                                                <Checkbox
                                                  checked={item.is_double_visit || false}
                                                  onChange={() => setSelecteddeleteuser3(item)}
                                                  sx={{
                                                    color: item.is_double_visit ? "#10b981" : "#9ca3af",
                                                    '&.Mui-checked': {
                                                      color: "#10b981",
                                                    },
                                                    '&:hover': {
                                                      backgroundColor: "rgba(16, 185, 129, 0.1)",
                                                    },
                                                    padding: "4px",
                                                  }}
                                                />
                                              </div>
                                            </td>
                                            <td>
                                              <div
                                                className="font-semibold text-center"
                                                style={{
                                                  fontWeight: "bold",
                                                  fontSize: "20px",
                                                }}
                                              >
                                                {item.report_detail_id !== null
                                                  ? (
                                                    <Tooltip
                                                      title={"Aveti raportari in aceasta zi, imposibil de facut careva modificari"}
                                                      arrow
                                                      placement="top"
                                                    >
                                                      <MdOutlineDoneAll className="text-green-700 text-xl ml-4" />
                                                    </Tooltip>
                                                  ) : (
                                                    <Tooltip title="Sterge" arrow placement="top">
                                                      <IconButton
                                                        onClick={() => setSelecteddeleteuser(item)}
                                                        color="primary"
                                                        sx={{

                                                          fontSize: "16px",
                                                          borderRadius: "50%",
                                                          "&:hover": {
                                                            backgroundColor: "#a4adad",
                                                          },
                                                        }}
                                                      >
                                                        <AiOutlineUserDelete className="dark:text-gray-100" />
                                                      </IconButton>
                                                    </Tooltip>
                                                  )
                                                }
                                              </div>
                                            </td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                    <Transition appear show={isOpen7} as={Fragment}>
                                      <Dialog as="div" className="relative z-10" onClose={closeModal}>
                                        <Transition.Child
                                          as={Fragment}
                                          enter="ease-out duration-300"
                                          enterFrom="opacity-0"
                                          enterTo="opacity-100"
                                          leave="ease-in duration-200"
                                          leaveFrom="opacity-100"
                                          leaveTo="opacity-0"
                                        >
                                          <div className="fixed inset-0 bg-black bg-opacity-25" />
                                        </Transition.Child>

                                        <div className="fixed inset-0 overflow-y-auto">
                                          <div className="flex min-h-full items-center justify-center p-4 text-center">
                                            <Transition.Child
                                              as={Fragment}
                                              enter="ease-out duration-300"
                                              enterFrom="opacity-0 scale-95"
                                              enterTo="opacity-100 scale-100"
                                              leave="ease-in duration-200"
                                              leaveFrom="opacity-100 scale-100"
                                              leaveTo="opacity-0 scale-95"
                                            >
                                              <Dialog.Panel className="w-full max-w-lg transform overflow-x-auto rounded-2xl bg-white dark:bg-gray-800 p-6 text-left align-middle shadow-xl transition-all">
                                                <Dialog.Title
                                                  as="h3"
                                                  className="text-lg font-medium leading-6 text-gray-900 dark:text-white"
                                                >{selectedRow[0]?.doctor ? 'Istoric Doctor: ' + selectedRow[0]?.doctor : 'Istoric Farmacie: ' + selectedRow[0]?.institutie}

                                                </Dialog.Title>
                                                <div className="mt-2">

                                                  <div className="flex flex-wrap gap-2 items-center">
                                                    <div className="flex flex-row gap-2 xs:flex-wrap">
                                                      <div className="relative w-1/2 mt-3 xs:w-full">
                                                        <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 dark:text-gray-100">
                                                          Perioada: De la..
                                                        </label>
                                                        <DatePicker
                                                          selectedDate={dateFilter.from}
                                                          handleDateChange={(e) => setDateFilter({ ...dateFilter, from: e.target.value })}
                                                        />
                                                      </div>
                                                      <div className="relative w-1/2 mt-3 xs:w-full">
                                                        <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 dark:text-gray-100">
                                                          Perioada: Pana la..
                                                        </label>
                                                        <DatePicker
                                                          selectedDate={dateFilter.to}
                                                          handleDateChange={(e) => setDateFilter({ ...dateFilter, to: e.target.value })}
                                                        />
                                                      </div>
                                                    </div>
                                                    <div className="flex items-end h-full">
                                                      <button
                                                        onClick={() => setDateFilter({
                                                          from: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
                                                          to: dayjs().format('YYYY-MM-DD')
                                                        })}
                                                        className="mb-2 px-4 py-2 bg-gray-200 dark:bg-gray-700 rounded hover:bg-gray-300 dark:hover:bg-gray-600"
                                                      >
                                                        Resetează
                                                      </button>
                                                    </div>
                                                  </div>
                                                  <div className="relative h-[50vh] overflow-hidden">
                                                    <div className="absolute inset-0 overflow-y-auto">
                                                      <table className="table-auto w-full //max-xs:sr-only">
                                                        <thead className="sticky top-0 z-10 text-xs uppercase text-gray-500 dark:text-gray-500 bg-gray-100 dark:bg-gray-700 dark:bg-opacity-50 rounded-sm">
                                                          <tr>
                                                            <th className="p-2 whitespace-nowrap">
                                                              <div
                                                                className="font-semibold text-left cursor-pointer flex items-center "
                                                                onClick={() => requestSort('date')}
                                                              >
                                                                Data
                                                                {sortConfig.key === 'date' && (
                                                                  <span className="ml-1">
                                                                    {sortConfig.direction === 'asc' ? '↑' : '↓'}
                                                                  </span>
                                                                )}
                                                              </div>
                                                            </th>
                                                            {!isSpecialitateaEmpty && (
                                                              <th className="p-2">
                                                                <div className="font-semibold text-left">Specialitatea</div>
                                                              </th>
                                                            )}

                                                            <th className="p-2">
                                                              <div className="font-semibold text-left">Institutia</div>
                                                            </th>
                                                            <th className="p-2">
                                                              <div className="font-semibold text-left">Adresa</div>
                                                            </th>
                                                            <th className="p-2">
                                                              <div className="font-semibold text-left">Oras</div>
                                                            </th>
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          {filteredData?.map((item, idx) => (
                                                            <tr
                                                              key={idx}
                                                              className={`text-sm font-medium divide-y divide-gray-100 dark:divide-gray-700/60 ${idx % 2 === 0 ? "bg-gray-0 dark:bg-gray-800" : "bg-gray-100 dark:bg-gray-700"}`}
                                                            >
                                                              <td className="p-2 whitespace-nowrap">
                                                                <div className="text-left font-bold">
                                                                  {dayjs(item.date, "DD-MM-YYYY", true).format("DD-MM-YYYY")}
                                                                </div>
                                                              </td>
                                                              <td className={item.specialitatea === null ? 'hidden' : 'p-2'}>
                                                                <div className="text-left">
                                                                  {item.specialitatea}
                                                                </div>
                                                              </td>
                                                              <td className="p-2">
                                                                <div className="text-left">
                                                                  {item.institutie + ' - ' + item.adresa + ' - ' + item.oras_sat}
                                                                </div>
                                                              </td>
                                                              <td className="p-2">
                                                                <div className="text-left text-wrap">
                                                                  {item.comment || '-'}
                                                                </div>
                                                              </td>
                                                            </tr>
                                                          ))}
                                                        </tbody>
                                                      </table>
                                                    </div>
                                                  </div>
                                                </div>

                                                <div className="mt-4">
                                                  <button
                                                    type="button"
                                                    className="px-4 py-2 rounded bg-gray-800 text-gray-100 hover:bg-gray-500 dark:bg-gray-100 dark:text-gray-800"
                                                    onClick={closeModal}
                                                  >
                                                    Inchide
                                                  </button>
                                                </div>
                                              </Dialog.Panel>
                                            </Transition.Child>
                                          </div>
                                        </div>
                                      </Dialog>
                                    </Transition>

                                  </>
                                ) : ("")}
                              </div>

                              {Data2.filter((i) => i.planning_day_id === selectedInstitutionId1.planning_day_id).length > 5 && (
                                <div className="flex justify-center mt-4 max-xs:sr-only">
                                  <button
                                    onClick={() => setCurrentPage1((prev) => Math.max(prev - 1, 1))}
                                    className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-sm font-medium rounded-l-md hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50"
                                    disabled={currentPage1 === 1}
                                  >
                                    Prev
                                  </button>

                                  {currentPage1 > 3 && (
                                    <>
                                      <button
                                        onClick={() => setCurrentPage1(1)}
                                        className="px-4 py-2 text-sm font-medium bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                                      >
                                        1
                                      </button>
                                      <span className="px-2">...</span>
                                    </>
                                  )}

                                  {Array.from({ length: totalPages1 }, (_, index) => {
                                    const page = index + 1;

                                    if (
                                      page === currentPage1 ||
                                      (page >= currentPage1 - 1 && page <= currentPage1 + 1)
                                    ) {
                                      return (
                                        <button
                                          key={page}
                                          onClick={() => setCurrentPage1(page)}
                                          className={`px-4 py-2 text-sm font-medium ${currentPage1 === page
                                            ? "bg-gray-500 text-white"
                                            : "bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                                            }`}
                                        >
                                          {page}
                                        </button>
                                      );
                                    }
                                    return null;
                                  })}

                                  {currentPage1 < totalPages1 - 2 && (
                                    <>
                                      <span className="px-2">...</span>
                                      <button
                                        onClick={() => setCurrentPage1(totalPages1)}
                                        className="px-4 py-2 text-sm font-medium bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                                      >
                                        {totalPages1}
                                      </button>
                                    </>
                                  )}

                                  <button
                                    onClick={() =>
                                      setCurrentPage1((prev) => Math.min(prev + 1, totalPages1))
                                    }
                                    className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-sm font-medium rounded-r-md hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50"
                                    disabled={currentPage1 === totalPages1}
                                  >
                                    Next
                                  </button>
                                </div>
                              )}

                              <div className="overflow-x-auto mt-4">
                                <h2 className="font-semibold text-gray-700 dark:text-gray-200 max-xs:sr-only">
                                  {Data3.filter((i) => i.planning_day_id === selectedInstitutionId1.planning_day_id).length > 0 ? "Alte activitati" : ""}</h2>
                                {Data3.filter((i) => i.planning_day_id === selectedInstitutionId1.planning_day_id).length > 0 ? (
                                  <table className="w-full max-xs:sr-only">
                                    <thead className="text-xs uppercase text-gray-500 dark:text-gray-500 bg-gray-100 dark:bg-gray-700 dark:bg-opacity-50 rounded-sm">
                                      <tr>
                                        <th className="p-2">
                                          <div className="font-semibold text-left">Activitatea</div>
                                        </th>
                                        <th className="p-2">
                                          <div className="font-semibold text-left">Interval ora</div>
                                        </th>
                                        <th className="p-2">
                                          <div className="font-semibold text-left">Tip</div>
                                        </th>
                                        <th className="p-2">
                                          <div className="font-semibold text-left">Institutia</div>
                                        </th>
                                        <th className="p-2">
                                          <div className="font-semibold text-left">Specialitatea</div>
                                        </th>
                                        <th className="p-2">
                                          <div className="font-semibold text-left">Numar. pers.</div>
                                        </th>
                                        <th className="p-2">
                                          <div className="font-semibold text-left">Comentariu</div>
                                        </th>
                                        <th className="p-2">
                                          <div className="font-semibold text-left">Actiune</div>
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {Data3.filter((i) => i.planning_day_id === selectedInstitutionId1?.planning_day_id).map((item, idx) => {
                                        return (
                                          <React.Fragment key={idx}>
                                            <tr key={idx} className={`text-sm font-medium divide-y divide-gray-100 dark:divide-gray-700/60 ${idx % 2 === 0 ? "bg-gray-0 dark:bg-gray-800" : "bg-gray-100 dark:bg-gray-700"}`}>
                                              <td className="p-2 whitespace-normal">
                                                {item.activity_type}

                                              </td>
                                              <td className="p-2 whitespace-nowrap flex items-center">
                                                {
                                                  item.start_time && item.end_time && dayjs(item.start_time).isValid() && dayjs(item.end_time).isValid()
                                                    ? (<span>{dayjs.utc(item.start_time).format('HH:mm')} - {dayjs.utc(item.end_time).format('HH:mm')}</span>) : (
                                                      <span>{item.start_time} - {item.end_time}</span>)
                                                }
                                                <div
                                                  className="font-semibold text-center"
                                                  style={{
                                                    fontWeight: "bold",
                                                    fontSize: "20px",
                                                  }}
                                                >
                                                  <Tooltip title="Editeaza" arrow placement="top">
                                                    <IconButton
                                                      onClick={() => setSelecteddeleteuser1(item)}
                                                      color="primary"
                                                      sx={{
                                                        fontSize: "16px",
                                                        borderRadius: "50%",
                                                        "&:hover": {
                                                          backgroundColor: "#a4adad",
                                                        },
                                                      }}
                                                    >
                                                      <AiFillEdit className="dark:text-gray-100" />
                                                      <Transition appear show={open6} as={Fragment}>
                                                        <Dialog as="div" className="relative z-10" onClose={() => setOpen6(false)}>
                                                          <Transition.Child
                                                            as={Fragment}
                                                            enter="ease-out duration-300"
                                                            enterFrom="opacity-0"
                                                            enterTo="opacity-100"
                                                            leave="ease-in duration-200"
                                                            leaveFrom="opacity-100"
                                                            leaveTo="opacity-0"
                                                          >
                                                            <div className="fixed inset-0 bg-black bg-opacity-25" />
                                                          </Transition.Child>

                                                          <div className="fixed inset-0 overflow-y-auto">
                                                            <div className="flex min-h-full items-center justify-center p-4 text-center">
                                                              <Transition.Child
                                                                as={Fragment}
                                                                enter="ease-out duration-300"
                                                                enterFrom="opacity-0 scale-95"
                                                                enterTo="opacity-100 scale-100"
                                                                leave="ease-in duration-200"
                                                                leaveFrom="opacity-100 scale-100"
                                                                leaveTo="opacity-0 scale-95"
                                                              >
                                                                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-lg bg-white p-6 text-left align-middle shadow-xl transition-all dark:bg-gray-800">
                                                                  <Dialog.Title as="h3" className="text-lg font-bold leading-6 text-gray-900  dark:text-gray-200">
                                                                    Selectează Ora
                                                                  </Dialog.Title>
                                                                  <div className="mt-4">
                                                                    <form className="max-w-[16rem] mx-auto grid grid-cols-2 gap-4">
                                                                      <div>
                                                                        <label htmlFor="start-time" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                                                          Start ora:
                                                                        </label>
                                                                        <div className="relative">
                                                                          <div className="absolute inset-y-0 end-0 top-0 flex items-center pe-3.5 pointer-events-none">
                                                                            <svg
                                                                              className="w-4 h-4 text-gray-500 dark:text-gray-400"
                                                                              aria-hidden="true"
                                                                              xmlns="http://www.w3.org/2000/svg"
                                                                              fill="currentColor"
                                                                              viewBox="0 0 24 24"
                                                                            >
                                                                              <path
                                                                                fillRule="evenodd"
                                                                                clipRule="evenodd"
                                                                              />
                                                                            </svg>
                                                                          </div>
                                                                          <input
                                                                            type="time"
                                                                            id="start-time"
                                                                            className="bg-gray-50 border leading-none border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                                            value={startTime ? dayjs.utc(startTime, "HH:mm").format("HH:mm") : ""}
                                                                            onChange={handleStartTimeChange}
                                                                            name="appt" min="09:00" max="18:00"
                                                                            required
                                                                          />
                                                                        </div>
                                                                      </div>
                                                                      <div>
                                                                        <label htmlFor="end-time" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                                                          End ora:
                                                                        </label>
                                                                        <div className="relative">
                                                                          <div className="absolute inset-y-0 end-0 top-0 flex items-center pe-3.5 pointer-events-none">
                                                                            <svg
                                                                              className="w-4 h-4 text-gray-500 dark:text-gray-400"
                                                                              aria-hidden="true"
                                                                              xmlns="http://www.w3.org/2000/svg"
                                                                              fill="currentColor"
                                                                              viewBox="0 0 24 24"
                                                                            >
                                                                              <path
                                                                                fillRule="evenodd"
                                                                                clipRule="evenodd"
                                                                              />
                                                                            </svg>
                                                                          </div>
                                                                          <input
                                                                            type="time"
                                                                            id="end-time"
                                                                            className="bg-gray-50 border leading-none border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                                            value={endTime ? dayjs.utc(endTime, "HH:mm").format("HH:mm") : ""}
                                                                            onChange={handleEndTimeChange}
                                                                            required
                                                                          />
                                                                        </div>
                                                                      </div>
                                                                    </form>
                                                                  </div>

                                                                  <div className="mt-4 flex justify-end gap-2">
                                                                    <button
                                                                      className="px-4 py-2 rounded bg-gray-200 text-gray-700 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-200"
                                                                      onClick={() => { setOpen6(false); setSelecteddeleteuser1() }}
                                                                    >
                                                                      Anulează
                                                                    </button>

                                                                    <button
                                                                      className={`btn ${isLoading
                                                                        ? "bg-gray-500 text-gray-300"
                                                                        : "bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white"}`}
                                                                      onClick={handleButtonClick6}
                                                                      disabled={isLoading}
                                                                    >
                                                                      {isLoading ? (
                                                                        <svg
                                                                          className="animate-spin fill-current shrink-0 xs:hidden"
                                                                          width="16"
                                                                          height="16"
                                                                          viewBox="0 0 16 16"
                                                                        >
                                                                          <circle
                                                                            className="opacity-25"
                                                                            cx="8"
                                                                            cy="8"
                                                                            r="7"
                                                                            stroke="currentColor"
                                                                            strokeWidth="2" />
                                                                          <path
                                                                            className="opacity-75"
                                                                            d="M12 2a6 6 0 000 12V2z" />
                                                                        </svg>
                                                                      ) : (
                                                                        <svg
                                                                          className="fill-current shrink-0 xs:hidden"
                                                                          width="16"
                                                                          height="16"
                                                                          viewBox="0 0 16 16"
                                                                        >
                                                                          <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                                                        </svg>
                                                                      )}
                                                                      <span className="//max-xs:sr-only">
                                                                        {isLoading ? "Saving..." : "Salveaza detaliile"}
                                                                      </span>
                                                                    </button>
                                                                  </div>
                                                                </Dialog.Panel>
                                                              </Transition.Child>
                                                            </div>
                                                          </div>
                                                        </Dialog>
                                                      </Transition>
                                                    </IconButton>
                                                  </Tooltip>
                                                </div>
                                              </td>
                                              <td className="p-2 ">
                                                {item.location?.inst_type || "Nu exista institutie"}
                                              </td>
                                              <td className="p-2">
                                                {
                                                  item.location?.institution ? (item.location?.institution + " - " + item.location?.address + " - " + item.location?.city) : "Nu exista institutie"
                                                }
                                              </td>
                                              <td className="p-2 //whitespace-nowrap">
                                                {item.activity?.speciality || "Nu exista specialitate"}
                                              </td>
                                              <td className="p-2 //whitespace-nowrap">
                                                {item.persons}
                                              </td>
                                              <td className="p-2 whitespace-nowrap text-blue-500 underline cursor-pointer" onClick={() => setOpenRow(openRow === item.index ? null : item.index)}>Afiseaza</td>

                                              <td>
                                                <div
                                                  className="font-semibold text-center"
                                                  style={{
                                                    fontWeight: "bold",
                                                    fontSize: "20px",
                                                  }}
                                                >
                                                  <Tooltip title="Editeaza" arrow placement="top">
                                                    <IconButton
                                                      onClick={() => setSelecteddeleteuser2(item)}
                                                      color="primary"
                                                      sx={{
                                                        fontSize: "16px",
                                                        borderRadius: "50%",
                                                        "&:hover": {
                                                          backgroundColor: "#a4adad",
                                                        },
                                                      }}
                                                    >
                                                      <AiFillEdit className="dark:text-gray-100" />
                                                      <Transition appear show={open3} as={Fragment}>
                                                        <Dialog as="div" className="relative z-10" onClose={() => setOpen3(false)}>
                                                          <Transition.Child
                                                            as={Fragment}
                                                            enter="ease-out duration-300"
                                                            enterFrom="opacity-0"
                                                            enterTo="opacity-100"
                                                            leave="ease-in duration-200"
                                                            leaveFrom="opacity-100"
                                                            leaveTo="opacity-0"
                                                          >
                                                            <div className="fixed inset-0 bg-black bg-opacity-25" />
                                                          </Transition.Child>

                                                          <div className="fixed inset-0 overflow-y-auto">
                                                            <div className="flex min-h-full items-center justify-center p-4 text-center">
                                                              <Transition.Child
                                                                as={Fragment}
                                                                enter="ease-out duration-300"
                                                                enterFrom="opacity-0 scale-95"
                                                                enterTo="opacity-100 scale-100"
                                                                leave="ease-in duration-200"
                                                                leaveFrom="opacity-100 scale-100"
                                                                leaveTo="opacity-0 scale-95"
                                                              >
                                                                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-lg bg-white p-6 text-left align-middle shadow-xl transition-all dark:bg-gray-800">
                                                                  <Dialog.Title as="h3" className="text-lg font-bold leading-6 text-gray-900 dark:text-gray-200">
                                                                    Editeaza activitatea
                                                                  </Dialog.Title>

                                                                  <div className="relative mt-4">
                                                                    <label className="z-10 absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800">Institutia</label>
                                                                    <Select
                                                                      options={dropdownOptions2}
                                                                      placeholder="Caută instituția..."
                                                                      defaultValue={dropdownOptions2.find((opt) => opt.value === defaultOption2)}
                                                                      onChange={(e) => _onSelect2(e.value)}
                                                                      classNamePrefix="custom-select"
                                                                      isSearchable={true}
                                                                      menuPortalTarget={document.body}
                                                                      styles={{
                                                                        control: (provided) => ({
                                                                          ...provided,
                                                                          width: '100%',
                                                                          borderRadius: '0.375rem',
                                                                          borderColor: '#BFC4CD',
                                                                          boxShadow: 'none',
                                                                          zIndex: 0,
                                                                          height: "45px",
                                                                          color: isDarkMode ? '#FFFFFF' : '#1F2937',
                                                                          backgroundColor: isDarkMode ? '#1f2937' : provided.backgroundColor,
                                                                        }),
                                                                        menuPortal: (base) => ({
                                                                          ...base,
                                                                          zIndex: 9999,
                                                                          color: isDarkMode ? 'black' : base.backgroundColor,
                                                                        }),
                                                                        singleValue: provided => ({
                                                                          ...provided,
                                                                          color: isDarkMode ? '#FFFFFF' : '#1F2937',
                                                                        })
                                                                      }}
                                                                    />
                                                                  </div>

                                                                  <div className="relative mt-4">
                                                                    <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800">Specialitatea</label>
                                                                    <select
                                                                      className="w-full p-3 border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-100 focus:ring-2 focus:ring-blue-500"
                                                                      value={defaultOption3}
                                                                      onChange={(e) => _onSelect3(e.target.value)}
                                                                    >
                                                                      <option value="" disabled>Alege activitatea</option>
                                                                      {dropdownOptions3.map((option) => (
                                                                        <option key={option.value} value={option.value}>{option.label}</option>
                                                                      ))}
                                                                    </select>
                                                                  </div>

                                                                  <div className="relative mt-4">
                                                                    <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800">Numarul de persoane</label>
                                                                    <input
                                                                      type="number"
                                                                      className="w-full p-3 border border-gray-300 rounded-md dark:bg-gray-800 dark:text-gray-100 focus:ring-2 focus:ring-blue-500"
                                                                      value={defaultOption5 || ""}
                                                                      onChange={(e) => {
                                                                        const newValue = e.target.value;
                                                                        setDefaultOption5(newValue);
                                                                      }}
                                                                    />
                                                                  </div>

                                                                  <div className="relative mt-4">
                                                                    <label className="absolute -top-3 left-2 text-sm bg-white px-1 z-10 dark:bg-gray-800">Comentariu</label>
                                                                    <textarea
                                                                      id="message"
                                                                      rows="4"
                                                                      className="block p-2.5 w-full text-sm text-gray-900  rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-800 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                                                      placeholder="Scrie aici..."
                                                                      value={coment}
                                                                      onChange={handleChangecom}
                                                                    />
                                                                  </div>

                                                                  <div className="mt-4 flex justify-end gap-2">
                                                                    <button
                                                                      className="px-4 py-2 rounded bg-gray-200 text-gray-700 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-200"
                                                                      onClick={() => setOpen3(false)}
                                                                    >
                                                                      Anulează
                                                                    </button>

                                                                    <button
                                                                      className={`btn ${isLoading
                                                                        ? "bg-gray-500 text-gray-300"
                                                                        : "bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white"}`}
                                                                      onClick={handleButtonClick3}
                                                                      disabled={isLoading}
                                                                    >
                                                                      {isLoading ? (
                                                                        <svg
                                                                          className="animate-spin fill-current shrink-0 xs:hidden"
                                                                          width="16"
                                                                          height="16"
                                                                          viewBox="0 0 16 16"
                                                                        >
                                                                          <circle
                                                                            className="opacity-25"
                                                                            cx="8"
                                                                            cy="8"
                                                                            r="7"
                                                                            stroke="currentColor"
                                                                            strokeWidth="2"
                                                                          />
                                                                          <path
                                                                            className="opacity-75"
                                                                            d="M12 2a6 6 0 000 12V2z"
                                                                          />
                                                                        </svg>
                                                                      ) : (
                                                                        <svg
                                                                          className="fill-current shrink-0 xs:hidden"
                                                                          width="16"
                                                                          height="16"
                                                                          viewBox="0 0 16 16"
                                                                        >
                                                                          <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                                                        </svg>
                                                                      )}
                                                                      <span className="//max-xs:sr-only">
                                                                        {isLoading ? "Saving..." : "Salveaza detaliile"}
                                                                      </span>
                                                                    </button>
                                                                  </div>
                                                                </Dialog.Panel>
                                                              </Transition.Child>
                                                            </div>
                                                          </div>
                                                        </Dialog>
                                                      </Transition>
                                                    </IconButton>
                                                  </Tooltip>
                                                  <Tooltip title="Sterge" arrow placement="top">
                                                    {item.report_detail_id !== null
                                                      ? (
                                                        <Tooltip
                                                          title={"Aveti raportari in aceasta zi, imposibil de facut careva modificari"}
                                                          arrow
                                                          placement="top"
                                                        >
                                                          <MdOutlineDoneAll className="text-green-700 text-xl ml-4" />
                                                        </Tooltip>
                                                      ) : (
                                                        <IconButton
                                                          onClick={() => setSelecteddeleteuser7(item)}
                                                          color="primary"
                                                          sx={{
                                                            fontSize: "16px",
                                                            borderRadius: "50%",
                                                            "&:hover": {
                                                              backgroundColor: "#a4adad",
                                                            },
                                                          }}
                                                        >
                                                          <AiOutlineUserDelete className="dark:text-gray-100" />
                                                        </IconButton>
                                                      )}
                                                  </Tooltip>
                                                </div>
                                              </td>
                                            </tr>
                                            {openRow === item.index && (
                                              <tr className="bg-gray-50 dark:bg-gray-800">
                                                <td colSpan="11" className="p-4">
                                                  <div className="text-sm text-gray-800 dark:text-gray-200 flex justify-between">
                                                    <div className="flex gap-1">
                                                      <strong>Comentariu:</strong>
                                                      <span style={{ width: '90%', display: 'block', wordWrap: 'break-word' }}>{item.comment || "Niciun comentariu"}</span>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>
                                            )}
                                          </React.Fragment>
                                        );
                                      })}
                                    </tbody>
                                  </table>

                                ) : ("")}
                              </div>
                              <>
                                <h2 className="font-semibold text-gray-700 dark:text-gray-200 xs:hidden">Vizite </h2>

                                <table className="w-full">
                                  <tbody>
                                    {Data2.filter((i) => i.planning_day_id === selectedInstitutionId1?.planning_day_id).map((item, idx) => {
                                      return (
                                        <React.Fragment key={idx}>
                                          <tr>
                                            <td>
                                              <div className="sm:hidden mb-4 p-3 rounded-lg bg-gray-100 dark:bg-gray-700">
                                                <div className="grid grid-cols-1 gap-2">
                                                  <div className="flex items-center gap-2 p-2">
                                                    <div>
                                                      <h3 className="text-gray-900 dark:text-gray-100 flex items-center gap-1.5">
                                                        {item.obiect_type_id === 1 ? (
                                                          <>
                                                            <span>{item.physician?.name || item.physician}</span>
                                                            {(item.physician?.data_acord || item.data_acord) ? (
                                                              <span title="Acord marketing confirmat" className="inline-flex items-center text-emerald-500 flex-shrink-0">
                                                                <svg className="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                                                                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                                                </svg>
                                                              </span>
                                                            ) : null}
                                                          </>
                                                        ) : (
                                                          item.location?.institution
                                                        )}
                                                      </h3>

                                                      <div className="text-md text-gray-500 dark:text-gray-400">
                                                        {item.location?.inst_type || "Nu exista institutie"}
                                                      </div>

                                                      <div className="text-md text-gray-500 dark:text-gray-400">
                                                        {item.obiect_type_id === 1 ?
                                                          item.physician?.speciality + " - " + item.location?.institution
                                                          : null}
                                                      </div>

                                                      <div className="text-md text-gray-500 dark:text-gray-400">
                                                        {item.location?.address + " - " + item.location?.city}
                                                      </div>
                                                    </div>
                                                  </div>

                                                  <div className="flex justify-end items-center">
                                                    <div className="flex gap-1">
                                                      {item.report_detail_id !== null
                                                        ? (
                                                          <Tooltip
                                                            title={"Aveti raportari in aceasta zi, imposibil de facut careva modificari"}
                                                            arrow
                                                            placement="top"
                                                          >
                                                            <MdOutlineDoneAll className="text-green-700 text-xl ml-4" />
                                                          </Tooltip>
                                                        ) : (

                                                          <>
                                                            <Tooltip title="Vizita Dubla" arrow placement="top">
                                                              <div className="inline-flex items-center ml-2">
                                                                <Checkbox
                                                                  checked={item.is_double_visit || false}
                                                                  onChange={() => setSelecteddeleteuser3(item)}
                                                                  sx={{
                                                                    color: item.is_double_visit ? "#10b981" : "#9ca3af",
                                                                    '&.Mui-checked': {
                                                                      color: "#10b981",
                                                                    },
                                                                    '&:hover': {
                                                                      backgroundColor: "rgba(16, 185, 129, 0.1)",
                                                                    },
                                                                    padding: "4px",
                                                                  }} />
                                                                <span className="text-xs ml-1 text-gray-600 dark:text-gray-300">
                                                                  Vizita Dublă
                                                                </span>
                                                              </div>
                                                            </Tooltip><Tooltip title="Sterge" arrow placement="top">
                                                              <IconButton
                                                                onClick={() => setSelecteddeleteuser(item)}
                                                                color="primary"
                                                                sx={{
                                                                  fontSize: "16px",
                                                                  borderRadius: "50%",
                                                                  "&:hover": {
                                                                    backgroundColor: "#a4adad",
                                                                  },
                                                                }}
                                                              >
                                                                <AiOutlineUserDelete className="dark:text-gray-100" />
                                                              </IconButton>
                                                            </Tooltip>
                                                          </>
                                                        )}

                                                      <Tooltip title="Istoric" arrow placement="top">
                                                        <IconButton
                                                          onClick={() => openModal(item)}
                                                          color="primary"
                                                          sx={{
                                                            fontSize: "16px",
                                                            borderRadius: "50%",
                                                            "&:hover": {
                                                              backgroundColor: "#a4adad",
                                                            },
                                                          }}
                                                        >
                                                          <MdWorkHistory className="dark:text-gray-100" />
                                                        </IconButton>
                                                      </Tooltip>

                                                      <Transition appear show={isOpen7} as={Fragment}>
                                                        <Dialog as="div" className="relative z-10" onClose={closeModal}>
                                                          <Transition.Child
                                                            as={Fragment}
                                                            enter="ease-out duration-300"
                                                            enterFrom="opacity-0"
                                                            enterTo="opacity-100"
                                                            leave="ease-in duration-200"
                                                            leaveFrom="opacity-100"
                                                            leaveTo="opacity-0"
                                                          >
                                                            <div className="fixed inset-0 bg-black bg-opacity-25" />
                                                          </Transition.Child>

                                                          <div className="fixed inset-0 overflow-y-auto">
                                                            <div className="flex min-h-full items-center justify-center p-4 text-center">
                                                              <Transition.Child
                                                                as={Fragment}
                                                                enter="ease-out duration-300"
                                                                enterFrom="opacity-0 scale-95"
                                                                enterTo="opacity-100 scale-100"
                                                                leave="ease-in duration-200"
                                                                leaveFrom="opacity-100 scale-100"
                                                                leaveTo="opacity-0 scale-95"
                                                              >
                                                                <Dialog.Panel className="w-full max-w-lg transform overflow-x-auto rounded-2xl bg-white dark:bg-gray-800 p-6 text-left align-middle shadow-xl transition-all">
                                                                  <Dialog.Title
                                                                    as="h3"
                                                                    className="text-lg font-medium leading-6 text-gray-900 dark:text-white"
                                                                  >{selectedRow[0]?.doctor ? 'Istoric Doctor: ' + selectedRow[0]?.doctor : 'Istoric Farmacie: ' + selectedRow[0]?.institutie}

                                                                  </Dialog.Title>
                                                                  <div className="mt-2">

                                                                    <div className="flex flex-wrap gap-2 items-center">
                                                                      <div className="flex flex-row gap-2 xs:flex-wrap">
                                                                        <div className="relative w-1/2 mt-3 xs:w-full">
                                                                          <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 dark:text-gray-100">
                                                                            Perioada: De la..
                                                                          </label>
                                                                          <DatePicker
                                                                            selectedDate={dateFilter.from}
                                                                            handleDateChange={(e) => setDateFilter({ ...dateFilter, from: e.target.value })}
                                                                          />
                                                                        </div>
                                                                        <div className="relative w-1/2 mt-3 xs:w-full">
                                                                          <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 dark:text-gray-100">
                                                                            Perioada: Pana la..
                                                                          </label>
                                                                          <DatePicker
                                                                            selectedDate={dateFilter.to}
                                                                            handleDateChange={(e) => setDateFilter({ ...dateFilter, to: e.target.value })}
                                                                          />
                                                                        </div>
                                                                      </div>
                                                                      <div className="flex items-end h-full">
                                                                        <button
                                                                          onClick={() => setDateFilter({
                                                                            from: dayjs().subtract(1, 'month').format('YYYY-MM-DD'),
                                                                            to: dayjs().format('YYYY-MM-DD')
                                                                          })}
                                                                          className="mb-2 px-4 py-2 bg-gray-200 dark:bg-gray-700 rounded hover:bg-gray-300 dark:hover:bg-gray-600"
                                                                        >
                                                                          Resetează
                                                                        </button>
                                                                      </div>
                                                                    </div>
                                                                    <div className="relative h-[50vh] overflow-hidden">
                                                                      <div className="absolute inset-0 overflow-y-auto">
                                                                        <table className="table-auto w-full //max-xs:sr-only">
                                                                          <thead className="sticky top-0 z-10 text-xs uppercase text-gray-500 dark:text-gray-500 bg-gray-100 dark:bg-gray-700 dark:bg-opacity-50 rounded-sm">
                                                                            <tr>
                                                                              <th className="p-2 whitespace-nowrap">
                                                                                <div
                                                                                  className="font-semibold text-left cursor-pointer flex items-center "
                                                                                  onClick={() => requestSort('date')}
                                                                                >
                                                                                  Data
                                                                                  {sortConfig.key === 'date' && (
                                                                                    <span className="ml-1">
                                                                                      {sortConfig.direction === 'asc' ? '↑' : '↓'}
                                                                                    </span>
                                                                                  )}
                                                                                </div>
                                                                              </th>
                                                                              {!isSpecialitateaEmpty && (
                                                                                <th className="p-2">
                                                                                  <div className="font-semibold text-left">Specialitatea</div>
                                                                                </th>
                                                                              )}

                                                                              <th className="p-2">
                                                                                <div className="font-semibold text-left">Institutia</div>
                                                                              </th>
                                                                              <th className="p-2">
                                                                                <div className="font-semibold text-left">Comentariu</div>
                                                                              </th>
                                                                            </tr>
                                                                          </thead>
                                                                          <tbody>
                                                                            {filteredData?.map((item, idx) => (
                                                                              <tr
                                                                                key={idx}
                                                                                className={`text-sm font-medium divide-y divide-gray-100 dark:divide-gray-700/60 ${idx % 2 === 0 ? "bg-gray-0 dark:bg-gray-800" : "bg-gray-100 dark:bg-gray-700"}`}
                                                                              >
                                                                                <td className="p-2 whitespace-nowrap">
                                                                                  <div className="text-left font-bold">
                                                                                    {dayjs(item.date, "DD-MM-YYYY", true).format("DD-MM-YYYY")}
                                                                                  </div>
                                                                                </td>
                                                                                <td className={item.specialitatea === null ? 'hidden' : 'p-2'}>
                                                                                  <div className="text-left">
                                                                                    {item.specialitatea}
                                                                                  </div>
                                                                                </td>
                                                                                <td className="p-2">
                                                                                  <div className="text-left">
                                                                                    {item.institutie + ' - ' + item.adresa + ' - ' + item.oras_sat}
                                                                                  </div>
                                                                                </td>
                                                                                <td className="p-2">
                                                                                  <div className="text-left text-wrap">
                                                                                    {item.comment || '-'}
                                                                                  </div>
                                                                                </td>
                                                                              </tr>
                                                                            ))}
                                                                          </tbody>
                                                                        </table>
                                                                      </div>
                                                                    </div>
                                                                  </div>

                                                                  <div className="mt-4">
                                                                    <button
                                                                      type="button"
                                                                      className="px-4 py-2 rounded bg-gray-800 text-gray-100 hover:bg-gray-500 dark:bg-gray-100 dark:text-gray-800"
                                                                      onClick={closeModal}
                                                                    >
                                                                      Inchide
                                                                    </button>
                                                                  </div>
                                                                </Dialog.Panel>
                                                              </Transition.Child>
                                                            </div>
                                                          </div>
                                                        </Dialog>
                                                      </Transition>

                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </td>
                                          </tr>
                                        </React.Fragment>
                                      );
                                    })}
                                  </tbody>
                                </table>

                                <h2 className="font-semibold text-gray-700 dark:text-gray-200 xs:hidden">Alte activitati</h2>

                                <table className="w-full">
                                  <tbody>
                                    {Data3.filter((i) => i.planning_day_id === selectedInstitutionId1?.planning_day_id).map((item, idx) => {
                                      return (
                                        <React.Fragment key={idx}>
                                          <tr>
                                            <td>
                                              <div className="sm:hidden mb-4 p-3 rounded-lg bg-gray-100 dark:bg-gray-700">
                                                <div className="grid grid-cols-1 gap-2">
                                                  <div className="font-medium">
                                                    <span className="text-gray-600 dark:text-gray-300">Activitate: </span>
                                                    {item.activity_type}

                                                  </div>

                                                  <div className="flex items-center justify-between">
                                                    <span className="text-gray-600 dark:text-gray-300">Interval orar: </span>
                                                    {
                                                      item.start_time && item.end_time && dayjs(item.start_time).isValid() && dayjs(item.end_time).isValid()
                                                        ? (<span>{dayjs.utc(item.start_time).format('HH:mm')} - {dayjs.utc(item.end_time).format('HH:mm')}</span>) : (
                                                          <span>{item.start_time} - {item.end_time}</span>)
                                                    }

                                                    <IconButton
                                                      onClick={() => setSelecteddeleteuser1(item)}
                                                      size="small"
                                                      sx={{
                                                        "&:hover": { backgroundColor: "#a4adad" },
                                                      }}
                                                    >
                                                      <AiFillEdit className="dark:text-gray-100" />
                                                    </IconButton>
                                                  </div>

                                                  <div>
                                                    <span className="text-gray-600 dark:text-gray-300">Instituție: </span>
                                                    {
                                                      item.location?.institution || "Nu exista institutie"
                                                    }
                                                  </div>

                                                  <div>
                                                    <span className="text-gray-600 dark:text-gray-300">Adresă: </span>
                                                    {
                                                      item.location?.address + " - " + item.location?.city || "Nu exista institutie"
                                                    }
                                                  </div>

                                                  <div>
                                                    <span className="text-gray-600 dark:text-gray-300">Specialitate: </span>
                                                    {item.activity?.speciality || "Nu exista specialitate"}
                                                  </div>

                                                  <div>
                                                    <span className="text-gray-600 dark:text-gray-300">Persoane: </span>
                                                    {item.persons}
                                                  </div>

                                                  <div className="flex justify-end items-center">
                                                    {/* <button
                                                      className="text-blue-500 underline"
                                                      onClick={() => setOpenRow(openRow === item.index ? null : item.index)}
                                                    >
                                                      {openRow === item.index ? "Ascunde" : "Afișează comentariu"}
                                                    </button> */}

                                                    <div className="flex gap-1">
                                                      <IconButton
                                                        onClick={() => setSelecteddeleteuser2(item)}
                                                        size="small"
                                                        sx={{
                                                          "&:hover": { backgroundColor: "#a4adad" },
                                                        }}
                                                      >
                                                        <AiFillEdit className="dark:text-gray-100" />
                                                      </IconButton>

                                                      {item.report_detail_id !== null
                                                        ? (
                                                          <Tooltip
                                                            title={"Aveti raportari in aceasta zi, imposibil de facut careva modificari"}
                                                            arrow
                                                            placement="top"
                                                          >
                                                            <MdOutlineDoneAll className="text-green-700 text-xl ml-4" />
                                                          </Tooltip>
                                                        ) : (
                                                          <IconButton
                                                            onClick={() => setSelecteddeleteuser7(item)}
                                                            size="small"
                                                            sx={{
                                                              "&:hover": { backgroundColor: "#a4adad" },
                                                            }}
                                                          >
                                                            <AiOutlineUserDelete className="dark:text-gray-100" />
                                                          </IconButton>
                                                        )}
                                                    </div>
                                                  </div>

                                                  {/* {openRow === item.index && (
                                                    <div className="mt-2 p-2 bg-gray-200 dark:bg-gray-600 rounded">
                                                      <strong>Comentariu:</strong>
                                                      <p className="break-words">{item.comment || "Niciun comentariu"}</p>
                                                    </div>
                                                  )} */}
                                                </div>
                                              </div>
                                            </td>
                                          </tr>
                                        </React.Fragment>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </>
                            </>
                          ) : (<h2 className="px-5 py-4 text-gray-600 dark:text-gray-400 ">Nu exista date in tabel.</h2>)}
                        </>
                        ) : (<h2 className="px-5 py-4 text-gray-600 dark:text-gray-400 ">Selectati ziua din tabelul de alaturi pentru a continua.</h2>)}
                      </div>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          </form>
        </div >
      )
      }
    </div >
  );
}

export default DashboardCard24edit;